/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { TransPb } from "../../gen/body/trans";
import { Vector3fPb } from "../../gen/eigen_lcm/Vector3f";
import {
  PhotoCaptureResult_Enum,
  photoCaptureResult_EnumFromJSON,
  photoCaptureResult_EnumToJSON,
} from "../../gen/user_camera/photo_capture_result";
import { PhotoFormat_Enum, photoFormat_EnumFromJSON, photoFormat_EnumToJSON } from "../../gen/user_camera/photo_format";
import { Uuid } from "../../gen/uuid_util/uuid";
import {
  FrameType_Enum,
  frameType_EnumFromJSON,
  frameType_EnumToJSON,
  LookAtWaypoint,
  PositionWaypoint,
  Waypoint,
} from "../../vehicle/skills/waypoints";

export const protobufPackage = "trajectory_action_planner";

/** Focus convergence state for photo waypoints */
export enum FocusState {
  /** FOCUS_INVALID - Default/unknown state */
  FOCUS_INVALID = 0,
  /** FOCUS_OFF - Autofocus is disabled, no waiting needed */
  FOCUS_OFF = 1,
  /** FOCUS_WAITING - Currently waiting for focus convergence */
  FOCUS_WAITING = 2,
  /** FOCUS_LOCK - Focus has converged/locked */
  FOCUS_LOCK = 3,
  /** FOCUS_TIMEOUT - Focus convergence timed out */
  FOCUS_TIMEOUT = 4,
  UNRECOGNIZED = -1,
}

export function focusStateFromJSON(object: any): FocusState {
  switch (object) {
    case 0:
    case "FOCUS_INVALID":
      return FocusState.FOCUS_INVALID;
    case 1:
    case "FOCUS_OFF":
      return FocusState.FOCUS_OFF;
    case 2:
    case "FOCUS_WAITING":
      return FocusState.FOCUS_WAITING;
    case 3:
    case "FOCUS_LOCK":
      return FocusState.FOCUS_LOCK;
    case 4:
    case "FOCUS_TIMEOUT":
      return FocusState.FOCUS_TIMEOUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FocusState.UNRECOGNIZED;
  }
}

export function focusStateToJSON(object: FocusState): string {
  switch (object) {
    case FocusState.FOCUS_INVALID:
      return "FOCUS_INVALID";
    case FocusState.FOCUS_OFF:
      return "FOCUS_OFF";
    case FocusState.FOCUS_WAITING:
      return "FOCUS_WAITING";
    case FocusState.FOCUS_LOCK:
      return "FOCUS_LOCK";
    case FocusState.FOCUS_TIMEOUT:
      return "FOCUS_TIMEOUT";
    case FocusState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum StopAtWaypointReason {
  INVALID = 0,
  STUCK = 1,
  LARGE_HEADING_CHANGE = 2,
  LOW_WAYPOINT_SPEED = 3,
  TRAJECTORY_DEFLECTION = 4,
  VEHICLE_BODY_VISIBLE = 5,
  ISP_NOT_READY = 6,
  PREV_PHOTO_STILL_ENQUEUED = 7,
  SHORT_DISTANCE_FROM_PREV_WAYPOINT = 8,
  GIMBAL_FLIP = 9,
  FIRST_WAYPOINT = 10,
  USER_REQUESTED = 11,
  UNRECOGNIZED = -1,
}

export function stopAtWaypointReasonFromJSON(object: any): StopAtWaypointReason {
  switch (object) {
    case 0:
    case "INVALID":
      return StopAtWaypointReason.INVALID;
    case 1:
    case "STUCK":
      return StopAtWaypointReason.STUCK;
    case 2:
    case "LARGE_HEADING_CHANGE":
      return StopAtWaypointReason.LARGE_HEADING_CHANGE;
    case 3:
    case "LOW_WAYPOINT_SPEED":
      return StopAtWaypointReason.LOW_WAYPOINT_SPEED;
    case 4:
    case "TRAJECTORY_DEFLECTION":
      return StopAtWaypointReason.TRAJECTORY_DEFLECTION;
    case 5:
    case "VEHICLE_BODY_VISIBLE":
      return StopAtWaypointReason.VEHICLE_BODY_VISIBLE;
    case 6:
    case "ISP_NOT_READY":
      return StopAtWaypointReason.ISP_NOT_READY;
    case 7:
    case "PREV_PHOTO_STILL_ENQUEUED":
      return StopAtWaypointReason.PREV_PHOTO_STILL_ENQUEUED;
    case 8:
    case "SHORT_DISTANCE_FROM_PREV_WAYPOINT":
      return StopAtWaypointReason.SHORT_DISTANCE_FROM_PREV_WAYPOINT;
    case 9:
    case "GIMBAL_FLIP":
      return StopAtWaypointReason.GIMBAL_FLIP;
    case 10:
    case "FIRST_WAYPOINT":
      return StopAtWaypointReason.FIRST_WAYPOINT;
    case 11:
    case "USER_REQUESTED":
      return StopAtWaypointReason.USER_REQUESTED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return StopAtWaypointReason.UNRECOGNIZED;
  }
}

export function stopAtWaypointReasonToJSON(object: StopAtWaypointReason): string {
  switch (object) {
    case StopAtWaypointReason.INVALID:
      return "INVALID";
    case StopAtWaypointReason.STUCK:
      return "STUCK";
    case StopAtWaypointReason.LARGE_HEADING_CHANGE:
      return "LARGE_HEADING_CHANGE";
    case StopAtWaypointReason.LOW_WAYPOINT_SPEED:
      return "LOW_WAYPOINT_SPEED";
    case StopAtWaypointReason.TRAJECTORY_DEFLECTION:
      return "TRAJECTORY_DEFLECTION";
    case StopAtWaypointReason.VEHICLE_BODY_VISIBLE:
      return "VEHICLE_BODY_VISIBLE";
    case StopAtWaypointReason.ISP_NOT_READY:
      return "ISP_NOT_READY";
    case StopAtWaypointReason.PREV_PHOTO_STILL_ENQUEUED:
      return "PREV_PHOTO_STILL_ENQUEUED";
    case StopAtWaypointReason.SHORT_DISTANCE_FROM_PREV_WAYPOINT:
      return "SHORT_DISTANCE_FROM_PREV_WAYPOINT";
    case StopAtWaypointReason.GIMBAL_FLIP:
      return "GIMBAL_FLIP";
    case StopAtWaypointReason.FIRST_WAYPOINT:
      return "FIRST_WAYPOINT";
    case StopAtWaypointReason.USER_REQUESTED:
      return "USER_REQUESTED";
    case StopAtWaypointReason.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PhotoCaptureWaypoint {
  lookAtWaypoint: LookAtWaypoint | undefined;
}

export interface PlanWaypoint {
  uuid:
    | Uuid
    | undefined;
  /**
   * A `PhotoCaptureWaypoint` implicitly mean a photo should be captured at this waypoint. Any
   * other type will be treated as a movement waypoint.
   */
  photo?:
    | PhotoCaptureWaypoint
    | undefined;
  /**
   * Movement waypoint without a specified heading and gimbal pitch, leaving the planner free to
   * choose the optimal values. This is the preffered type for a movment waypoint whenever
   * possible.
   */
  position?:
    | PositionWaypoint
    | undefined;
  /** Movement waypoint with a specific heading and gimbal. */
  pose?:
    | Waypoint
    | undefined;
  /**
   * Movement waypoint with a specific look at point, which could be in a different frame from the
   * waypoint.
   */
  lookAt?: LookAtWaypoint | undefined;
}

export interface PlanSettings {
  /**
   * The maximum amount of blur in pixels we will allow in the image when computing velocity limits.
   * Only applicable when PhotoCaptureMode is Trajectory.
   */
  maxAllowedBlurPixels: number;
  /** Disables any limits based on motion blur and makes `max_allowed_blur_pixels` unused */
  ignoreTranslationMotionBlurConstraint: boolean;
  /**
   * The max translational velocity that the vehicle is allowed to have at any point during the
   * execution of the plan
   */
  globalVelocityLimit: number;
  /**
   * The max angular velocity that the vehicle is allowed to have at any point during the execution
   * of the plan
   */
  globalAngularVelocityLimit: number;
  /**
   * The translational velocity limits on a waypoint should never be set lower than this. Set to 0
   * to disable.
   */
  globalMinimumWaypointVelocity: number;
  /**
   * Should we take a best-effort photo when we are unable to reach the photo waypoint?
   * TODO(Matias): Implement this
   */
  takeBestEffortPhotoWhenFailing: boolean;
  eoPhotoFormats: PhotoFormat_Enum[];
  irPhotoFormats: PhotoFormat_Enum[];
  eoJpegQuality: number;
  /** The behavior to be used for Photo Waypoints */
  photoCaptureMode: PlanSettings_PhotoCaptureMode;
}

/**
 * TODO(Ayush): moving this to the photo waypoint offers more flexibility. Move it there after
 * figuring out per photo configuration for TrajectoryInspect args.
 */
export enum PlanSettings_PhotoCaptureMode {
  UNKNOWN = 0,
  /** TRAJECTORY - Execute the photo in trajectory mode, moving as fast as possible. */
  TRAJECTORY = 1,
  /** STOP_FOR_PHOTO - Come to a complete stop for the photo. */
  STOP_FOR_PHOTO = 2,
  /** STOP_FOR_PHOTO_WITH_AUTOFOCUS_WAIT - STOP_FOR_PHOTO plus wait for the focus to converge before triggering the photo. */
  STOP_FOR_PHOTO_WITH_AUTOFOCUS_WAIT = 3,
  UNRECOGNIZED = -1,
}

export function planSettings_PhotoCaptureModeFromJSON(object: any): PlanSettings_PhotoCaptureMode {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PlanSettings_PhotoCaptureMode.UNKNOWN;
    case 1:
    case "TRAJECTORY":
      return PlanSettings_PhotoCaptureMode.TRAJECTORY;
    case 2:
    case "STOP_FOR_PHOTO":
      return PlanSettings_PhotoCaptureMode.STOP_FOR_PHOTO;
    case 3:
    case "STOP_FOR_PHOTO_WITH_AUTOFOCUS_WAIT":
      return PlanSettings_PhotoCaptureMode.STOP_FOR_PHOTO_WITH_AUTOFOCUS_WAIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlanSettings_PhotoCaptureMode.UNRECOGNIZED;
  }
}

export function planSettings_PhotoCaptureModeToJSON(object: PlanSettings_PhotoCaptureMode): string {
  switch (object) {
    case PlanSettings_PhotoCaptureMode.UNKNOWN:
      return "UNKNOWN";
    case PlanSettings_PhotoCaptureMode.TRAJECTORY:
      return "TRAJECTORY";
    case PlanSettings_PhotoCaptureMode.STOP_FOR_PHOTO:
      return "STOP_FOR_PHOTO";
    case PlanSettings_PhotoCaptureMode.STOP_FOR_PHOTO_WITH_AUTOFOCUS_WAIT:
      return "STOP_FOR_PHOTO_WITH_AUTOFOCUS_WAIT";
    case PlanSettings_PhotoCaptureMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PlanRequest {
  utime: number;
  /** UUID of the photo plan */
  uuid: Uuid | undefined;
  settings: PlanSettings | undefined;
  waypoints: PlanWaypoint[];
  /** The frame waypoints are in. */
  frame: FrameType_Enum;
  globalMapSource: PlanRequest_GlobalMapSource;
}

/** The source of the global_map_T_nav transform, needed if frame is GLOBAL_MAP */
export enum PlanRequest_GlobalMapSource {
  UNKNOWN = 0,
  VISION = 1,
  GPS = 2,
  UNRECOGNIZED = -1,
}

export function planRequest_GlobalMapSourceFromJSON(object: any): PlanRequest_GlobalMapSource {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PlanRequest_GlobalMapSource.UNKNOWN;
    case 1:
    case "VISION":
      return PlanRequest_GlobalMapSource.VISION;
    case 2:
    case "GPS":
      return PlanRequest_GlobalMapSource.GPS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlanRequest_GlobalMapSource.UNRECOGNIZED;
  }
}

export function planRequest_GlobalMapSourceToJSON(object: PlanRequest_GlobalMapSource): string {
  switch (object) {
    case PlanRequest_GlobalMapSource.UNKNOWN:
      return "UNKNOWN";
    case PlanRequest_GlobalMapSource.VISION:
      return "VISION";
    case PlanRequest_GlobalMapSource.GPS:
      return "GPS";
    case PlanRequest_GlobalMapSource.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * NOTE(Matias): We consider the time "the photo was captured" to be the beginning of the
 * integration period.
 */
export interface PhotoCapture {
  /** The UUID of the waypoint that this photo was taken at */
  waypointUuid: Uuid | undefined;
  result: PhotoCapture_Result;
  /**
   * Will contain the result from the ISP if the photo failed. Will be `CAPTURE_SUCCESSFUL` unless
   * `result` is `FAILURE_USER_CAMERA_ERROR`.
   */
  userCameraResult: PhotoCaptureResult_Enum;
  /** Copy of the photo waypoint from the plan that this belongs to */
  photoWaypoint:
    | PlanWaypoint
    | undefined;
  /** The pose of the photo capture in the reference frame */
  referenceTPhotoRDF: TransPb | undefined;
  photoFilePath: string;
  photoType: PhotoCapture_PhotoType;
  format: PhotoFormat_Enum;
  mediaId: string;
  /** Utime of the terminal photo capture response message */
  photoCaptureUtime: number;
  /**
   * The pose of the waypoint in the gimbal IMU frame. For a perfectly positioned frame this will be
   * the zero vector and the identity quaternion. A perfectly positioned frame is one where the
   * photo started being exposed at the waypoint's pose.
   */
  gimbalImuTWaypointRDF:
    | TransPb
    | undefined;
  /** The gimbal IMU movement during the photo capture. */
  gimbalImuStartExpositionTGimbalImuEndExpositionRDF:
    | TransPb
    | undefined;
  /** Exposure time for this photo */
  exposureTimeS: number;
  /** Number of ground pixels travelled during the photo capture */
  captureSurfacePixelsTravelled: number;
  /** The velocity limits in the gimal IMU frame for this photo capture. */
  gimbalImuLinearVelocityLimit: number;
  gimbalImuAngularVelocityLimit: number;
  /** If waypoint was flagged stop_at_waypoint */
  stopAtWaypoint: boolean;
  stopAtWaypointReason: StopAtWaypointReason;
  /**
   * Maximum relative pitch between vehicle and gimbal during the photo capture. Helps figuring out
   * if vehicle was visible in the photo
   */
  minVehicleToGimbalPitch: number;
  /** Maximum gimbal roll during the photo capture. */
  maxGimbalRoll: number;
  /** Maximum gimbal roll velocity during the photo capture. Helps figuring out if gimbal flipped */
  maxGimbalRollRate: number;
  /** The utime of the photo request */
  ispPhotoRequestUtime: number;
  /**
   * The utime of the start of the photo integration (corresponds to capture response messages
   * utime)
   */
  ispPhotoCaptureUtime: number;
  /** The publish utime of CAPTURE_IN_PROGRESS_EXPOSED */
  ispInProgressExposedUtime: number;
  /** The publish utime of READY_FOR_NEXT */
  ispReadyForNextUtime: number;
  /** The publish utime of CAPTURE_SUCCESSFUL */
  ispCaptureSuccessfulUtime: number;
  /** The publish utime of CAPTURE_FAILED_* (if applicable) */
  ispCaptureFailedUtime: number;
  /** Time spent in focus convergence. Will be 0 if we did not try focus convergence. */
  focusConvergenceTimeS: number;
  /** Focus state when we enqueued the photo */
  focusStateAtEnqueue: FocusState;
}

export enum PhotoCapture_Result {
  /**
   * UNKNOWN - NOTE(Matias): Any `SUCCESS*` option means that a photo was taken, though with possible
   * caveats. Any `FAILURE*` option means that no photo was taken.
   * Default value
   */
  UNKNOWN = 0,
  /** SUCCESS - Photo captured successfully within limits */
  SUCCESS = 1,
  /** SUCCESS_LIMITS_EXCEEDED - Photo captured but exceeded the velocity limits and may be blurry */
  SUCCESS_LIMITS_EXCEEDED = 2,
  /**
   * SUCCESS_BEST_EFFORT_PHOTO - A photo was captured, but we were unable to reach the photo waypoint. And the photo was taken
   * as a "best effort photo".
   */
  SUCCESS_BEST_EFFORT_PHOTO = 3,
  /** FAILURE_ISP_ERROR - Failure due to ISP error. See `user_camera_result` for more details. */
  FAILURE_ISP_ERROR = 4,
  /** FAILURE_GAVE_UP_REACHING_WAYPOINT - We gave up trying reach the photo waypoint. A photo was not captured for the waypoint. */
  FAILURE_GAVE_UP_REACHING_WAYPOINT = 5,
  /** FAILURE_ISP_TIMEOUT - The response from the ISP timed out */
  FAILURE_ISP_TIMEOUT = 6,
  UNRECOGNIZED = -1,
}

export function photoCapture_ResultFromJSON(object: any): PhotoCapture_Result {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return PhotoCapture_Result.UNKNOWN;
    case 1:
    case "SUCCESS":
      return PhotoCapture_Result.SUCCESS;
    case 2:
    case "SUCCESS_LIMITS_EXCEEDED":
      return PhotoCapture_Result.SUCCESS_LIMITS_EXCEEDED;
    case 3:
    case "SUCCESS_BEST_EFFORT_PHOTO":
      return PhotoCapture_Result.SUCCESS_BEST_EFFORT_PHOTO;
    case 4:
    case "FAILURE_ISP_ERROR":
      return PhotoCapture_Result.FAILURE_ISP_ERROR;
    case 5:
    case "FAILURE_GAVE_UP_REACHING_WAYPOINT":
      return PhotoCapture_Result.FAILURE_GAVE_UP_REACHING_WAYPOINT;
    case 6:
    case "FAILURE_ISP_TIMEOUT":
      return PhotoCapture_Result.FAILURE_ISP_TIMEOUT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoCapture_Result.UNRECOGNIZED;
  }
}

export function photoCapture_ResultToJSON(object: PhotoCapture_Result): string {
  switch (object) {
    case PhotoCapture_Result.UNKNOWN:
      return "UNKNOWN";
    case PhotoCapture_Result.SUCCESS:
      return "SUCCESS";
    case PhotoCapture_Result.SUCCESS_LIMITS_EXCEEDED:
      return "SUCCESS_LIMITS_EXCEEDED";
    case PhotoCapture_Result.SUCCESS_BEST_EFFORT_PHOTO:
      return "SUCCESS_BEST_EFFORT_PHOTO";
    case PhotoCapture_Result.FAILURE_ISP_ERROR:
      return "FAILURE_ISP_ERROR";
    case PhotoCapture_Result.FAILURE_GAVE_UP_REACHING_WAYPOINT:
      return "FAILURE_GAVE_UP_REACHING_WAYPOINT";
    case PhotoCapture_Result.FAILURE_ISP_TIMEOUT:
      return "FAILURE_ISP_TIMEOUT";
    case PhotoCapture_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PhotoCapture_PhotoType {
  EO = 0,
  IR = 1,
  UNRECOGNIZED = -1,
}

export function photoCapture_PhotoTypeFromJSON(object: any): PhotoCapture_PhotoType {
  switch (object) {
    case 0:
    case "EO":
      return PhotoCapture_PhotoType.EO;
    case 1:
    case "IR":
      return PhotoCapture_PhotoType.IR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PhotoCapture_PhotoType.UNRECOGNIZED;
  }
}

export function photoCapture_PhotoTypeToJSON(object: PhotoCapture_PhotoType): string {
  switch (object) {
    case PhotoCapture_PhotoType.EO:
      return "EO";
    case PhotoCapture_PhotoType.IR:
      return "IR";
    case PhotoCapture_PhotoType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface CompletedWaypoint {
  /** The utime at which the waypoint was passed */
  utime: number;
  /** The UUID of the waypoint that was passed */
  waypointUuid:
    | Uuid
    | undefined;
  /**
   * TODO(Matias): Should we publish a point or a path segment indicating how close we got to the
   * waypoint?
   */
  result: CompletedWaypoint_Result;
}

/** The result of passing the waypoint */
export enum CompletedWaypoint_Result {
  UNKNOWN = 0,
  /** SUCCESS - The waypoint was reached and passed successfully */
  SUCCESS = 1,
  /** FAILURE_GAVE_UP_REACHING_WAYPOINT - We gave up trying to reach the waypoint */
  FAILURE_GAVE_UP_REACHING_WAYPOINT = 2,
  UNRECOGNIZED = -1,
}

export function completedWaypoint_ResultFromJSON(object: any): CompletedWaypoint_Result {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return CompletedWaypoint_Result.UNKNOWN;
    case 1:
    case "SUCCESS":
      return CompletedWaypoint_Result.SUCCESS;
    case 2:
    case "FAILURE_GAVE_UP_REACHING_WAYPOINT":
      return CompletedWaypoint_Result.FAILURE_GAVE_UP_REACHING_WAYPOINT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CompletedWaypoint_Result.UNRECOGNIZED;
  }
}

export function completedWaypoint_ResultToJSON(object: CompletedWaypoint_Result): string {
  switch (object) {
    case CompletedWaypoint_Result.UNKNOWN:
      return "UNKNOWN";
    case CompletedWaypoint_Result.SUCCESS:
      return "SUCCESS";
    case CompletedWaypoint_Result.FAILURE_GAVE_UP_REACHING_WAYPOINT:
      return "FAILURE_GAVE_UP_REACHING_WAYPOINT";
    case CompletedWaypoint_Result.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface PlanProgress {
  utime: number;
  /** Same as the UUID of the photo plan request this belongs to */
  planUuid:
    | Uuid
    | undefined;
  /**
   * When true, this indicates that the photo planner is complete executing the plan, all photos as
   * either completed, feiled or timed out and the photo planner will not perform any further
   * actions including sending any additional progress updates.
   */
  isComplete: boolean;
  /**
   * Ordered list of waypoint (both movement and photo waypoints) that have been passed since the
   * last progress update.
   */
  completedWaypoints: CompletedWaypoint[];
  /** The photo capture result of any photos that have been captured since the last progress update. */
  photoCaptures: PhotoCapture[];
  /** Estimated time to complete the current plan, in seconds. */
  estimatedTimeToCompletionS: number;
}

export interface WaypointStateDebug {
  waypoint: PlanWaypoint | undefined;
  isPhotoWaypoint: boolean;
  stopAtWaypoint: boolean;
  stopAtWaypointReason: StopAtWaypointReason;
  stopAtWaypointTimeoutStartUtime: number;
  estimatedTimeToReachWaypoint: number;
  requiresGimbalFlip: boolean;
  poseFrozen: boolean;
  isStuck: boolean;
  largeTrajectoryDeflection: boolean;
  /** Focus related attributes */
  focusTimeoutStartUtime: number;
  focusTimeoutEndUtime: number;
  focusState: FocusState;
}

export interface StuckDetectorDebug {
  timeSinceMinDistanceUpdate: number;
  minDistanceToWaypoint: number;
}

export interface TrajectoryPlanDebug {
  utime: number;
  planUuid: Uuid | undefined;
  navTReference: TransPb | undefined;
  stuckDetector: StuckDetectorDebug | undefined;
  waypoints: WaypointStateDebug[];
  predictedIspReadyTimeFromCurrent: number;
}

export interface WaypointVelocityLimitsDebug {
  pathVelocityLimit: number;
  linearVelocityLimit: number;
  angularVelocityLimit: number;
}

export interface MovementCmdDebug {
  utime: number;
  navTVehicle:
    | Vector3fPb
    | undefined;
  /**
   * The `target waypoint` is usually the next photo waypoint. But if there is no photo waypoints
   * within the current waypoint window, then it is the the last movement waypoint within the
   * window.
   */
  targetWaypointUuid: Uuid | undefined;
  distanceToTargetWaypointM: number;
  timeToTargetWaypointS: number;
  currentHeading: number;
  currentHeadingRate: number;
  currentPitch: number;
  hasGimbalTarget: boolean;
  targetWaypointHeadingTarget: number;
  targetWaypointHeadingDiff: number;
  targetWaypointPitchTarget: number;
  holdForPhoto: boolean;
  slowForPhoto: boolean;
  waypointsInWindow: number;
  /** All of these fields are expected to be `waypoints_in_window` elements long */
  waypointUuids: Uuid[];
  /** Velocity limits computed by `ApplyPhotoBlurLimits` */
  waypointLimitsPhotoBlur: WaypointVelocityLimitsDebug[];
  /** Velocity limits computed by `ApplyRotateForPhoto` */
  waypointLimitsRotateForPhoto: WaypointVelocityLimitsDebug[];
  /** Velocity limits computed by `ApplyMaximumPhotoCaptureFrequency` */
  waypointLimitsCaptureFrequency: WaypointVelocityLimitsDebug[];
  /** Velocity limits computed by `ApplySlowForPhotoLimits` */
  waypointLimitsSlowForPhoto: WaypointVelocityLimitsDebug[];
  /** Velocity limits computed by `ApplyHoldForPhotoLimits` */
  waypointLimitsHoldForPhoto: WaypointVelocityLimitsDebug[];
  /** The final limits */
  waypointLimitsFinal: WaypointVelocityLimitsDebug[];
}

export interface StopForPhotoDebug {
  utime: number;
  waypointUuid: Uuid | undefined;
  navTVehicle: Vector3fPb | undefined;
  navTWaypoint: Vector3fPb | undefined;
  distance: number;
  vehiclePitch: number;
  waypointPitch: number;
  pitchDiff: number;
  vehicleHeading: number;
  waypointHeading: number;
  headingDiff: number;
  hasReachedWaypoint: boolean;
  hasReachedVelocityLimit: boolean;
  readyForNextPhoto: boolean;
  currentTimeoutDuration: number;
  timedOut: boolean;
  vehicleBodyVisible: boolean;
}

export interface EnqueuedPhotoCaptureRequestDebug {
  utime: number;
  waypointUuid: Uuid | undefined;
  timedOut: boolean;
  linearVelocityLimitReached: boolean;
  angularVelocityLimitReached: boolean;
  timeSinceEnqueued: number;
  linearVelocityLimit: number;
  angularVelocityLimit: number;
  currentLinearVelocity: number;
  currentAngularVelocity: number;
}

export interface PhotoCaptureStateDebug {
  photoRequestNonce: number;
  photoFormat: PhotoFormat_Enum;
  waypointUuid: Uuid | undefined;
  requestUtime: number;
  captureUtime: number;
  inProgressExposedUtime: number;
  captureSuccessfulUtime: number;
  captureFailedUtime: number;
  readyForNextUtime: number;
  photoPath: string;
  resultValid: boolean;
  result: PhotoCaptureResult_Enum;
  velocityLimitTimedOut: boolean;
  ispResultTimedOut: boolean;
}

export interface ActivePhotoCapturesDebug {
  utime: number;
  activeEoPhotoCaptures: PhotoCaptureStateDebug[];
  activeIrPhotoCaptures: PhotoCaptureStateDebug[];
}

function createBasePhotoCaptureWaypoint(): PhotoCaptureWaypoint {
  return { lookAtWaypoint: undefined };
}

export const PhotoCaptureWaypoint = {
  encode(message: PhotoCaptureWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.lookAtWaypoint !== undefined) {
      LookAtWaypoint.encode(message.lookAtWaypoint, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoCaptureWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoCaptureWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.lookAtWaypoint = LookAtWaypoint.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PhotoCaptureWaypoint {
    return {
      lookAtWaypoint: isSet(object.lookAtWaypoint) ? LookAtWaypoint.fromJSON(object.lookAtWaypoint) : undefined,
    };
  },

  toJSON(message: PhotoCaptureWaypoint): unknown {
    const obj: any = {};
    if (message.lookAtWaypoint !== undefined) {
      obj.lookAtWaypoint = LookAtWaypoint.toJSON(message.lookAtWaypoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoCaptureWaypoint>, I>>(base?: I): PhotoCaptureWaypoint {
    return PhotoCaptureWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoCaptureWaypoint>, I>>(object: I): PhotoCaptureWaypoint {
    const message = createBasePhotoCaptureWaypoint();
    message.lookAtWaypoint = (object.lookAtWaypoint !== undefined && object.lookAtWaypoint !== null)
      ? LookAtWaypoint.fromPartial(object.lookAtWaypoint)
      : undefined;
    return message;
  },
};

function createBasePlanWaypoint(): PlanWaypoint {
  return { uuid: undefined, photo: undefined, position: undefined, pose: undefined, lookAt: undefined };
}

export const PlanWaypoint = {
  encode(message: PlanWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(10).fork()).ldelim();
    }
    if (message.photo !== undefined) {
      PhotoCaptureWaypoint.encode(message.photo, writer.uint32(18).fork()).ldelim();
    }
    if (message.position !== undefined) {
      PositionWaypoint.encode(message.position, writer.uint32(26).fork()).ldelim();
    }
    if (message.pose !== undefined) {
      Waypoint.encode(message.pose, writer.uint32(34).fork()).ldelim();
    }
    if (message.lookAt !== undefined) {
      LookAtWaypoint.encode(message.lookAt, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlanWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.photo = PhotoCaptureWaypoint.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.position = PositionWaypoint.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pose = Waypoint.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.lookAt = LookAtWaypoint.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanWaypoint {
    return {
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
      photo: isSet(object.photo) ? PhotoCaptureWaypoint.fromJSON(object.photo) : undefined,
      position: isSet(object.position) ? PositionWaypoint.fromJSON(object.position) : undefined,
      pose: isSet(object.pose) ? Waypoint.fromJSON(object.pose) : undefined,
      lookAt: isSet(object.lookAt) ? LookAtWaypoint.fromJSON(object.lookAt) : undefined,
    };
  },

  toJSON(message: PlanWaypoint): unknown {
    const obj: any = {};
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    if (message.photo !== undefined) {
      obj.photo = PhotoCaptureWaypoint.toJSON(message.photo);
    }
    if (message.position !== undefined) {
      obj.position = PositionWaypoint.toJSON(message.position);
    }
    if (message.pose !== undefined) {
      obj.pose = Waypoint.toJSON(message.pose);
    }
    if (message.lookAt !== undefined) {
      obj.lookAt = LookAtWaypoint.toJSON(message.lookAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanWaypoint>, I>>(base?: I): PlanWaypoint {
    return PlanWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanWaypoint>, I>>(object: I): PlanWaypoint {
    const message = createBasePlanWaypoint();
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    message.photo = (object.photo !== undefined && object.photo !== null)
      ? PhotoCaptureWaypoint.fromPartial(object.photo)
      : undefined;
    message.position = (object.position !== undefined && object.position !== null)
      ? PositionWaypoint.fromPartial(object.position)
      : undefined;
    message.pose = (object.pose !== undefined && object.pose !== null) ? Waypoint.fromPartial(object.pose) : undefined;
    message.lookAt = (object.lookAt !== undefined && object.lookAt !== null)
      ? LookAtWaypoint.fromPartial(object.lookAt)
      : undefined;
    return message;
  },
};

function createBasePlanSettings(): PlanSettings {
  return {
    maxAllowedBlurPixels: 0,
    ignoreTranslationMotionBlurConstraint: false,
    globalVelocityLimit: 0,
    globalAngularVelocityLimit: 0,
    globalMinimumWaypointVelocity: 0,
    takeBestEffortPhotoWhenFailing: false,
    eoPhotoFormats: [],
    irPhotoFormats: [],
    eoJpegQuality: 0,
    photoCaptureMode: 0,
  };
}

export const PlanSettings = {
  encode(message: PlanSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.maxAllowedBlurPixels !== 0) {
      writer.uint32(13).float(message.maxAllowedBlurPixels);
    }
    if (message.ignoreTranslationMotionBlurConstraint === true) {
      writer.uint32(40).bool(message.ignoreTranslationMotionBlurConstraint);
    }
    if (message.globalVelocityLimit !== 0) {
      writer.uint32(21).float(message.globalVelocityLimit);
    }
    if (message.globalAngularVelocityLimit !== 0) {
      writer.uint32(29).float(message.globalAngularVelocityLimit);
    }
    if (message.globalMinimumWaypointVelocity !== 0) {
      writer.uint32(77).float(message.globalMinimumWaypointVelocity);
    }
    if (message.takeBestEffortPhotoWhenFailing === true) {
      writer.uint32(32).bool(message.takeBestEffortPhotoWhenFailing);
    }
    writer.uint32(50).fork();
    for (const v of message.eoPhotoFormats) {
      writer.int32(v);
    }
    writer.ldelim();
    writer.uint32(58).fork();
    for (const v of message.irPhotoFormats) {
      writer.int32(v);
    }
    writer.ldelim();
    if (message.eoJpegQuality !== 0) {
      writer.uint32(64).uint32(message.eoJpegQuality);
    }
    if (message.photoCaptureMode !== 0) {
      writer.uint32(80).int32(message.photoCaptureMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlanSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.maxAllowedBlurPixels = reader.float();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.ignoreTranslationMotionBlurConstraint = reader.bool();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.globalVelocityLimit = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.globalAngularVelocityLimit = reader.float();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.globalMinimumWaypointVelocity = reader.float();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.takeBestEffortPhotoWhenFailing = reader.bool();
          continue;
        case 6:
          if (tag === 48) {
            message.eoPhotoFormats.push(reader.int32() as any);

            continue;
          }

          if (tag === 50) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.eoPhotoFormats.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 7:
          if (tag === 56) {
            message.irPhotoFormats.push(reader.int32() as any);

            continue;
          }

          if (tag === 58) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.irPhotoFormats.push(reader.int32() as any);
            }

            continue;
          }

          break;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.eoJpegQuality = reader.uint32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.photoCaptureMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanSettings {
    return {
      maxAllowedBlurPixels: isSet(object.maxAllowedBlurPixels) ? globalThis.Number(object.maxAllowedBlurPixels) : 0,
      ignoreTranslationMotionBlurConstraint: isSet(object.ignoreTranslationMotionBlurConstraint)
        ? globalThis.Boolean(object.ignoreTranslationMotionBlurConstraint)
        : false,
      globalVelocityLimit: isSet(object.globalVelocityLimit) ? globalThis.Number(object.globalVelocityLimit) : 0,
      globalAngularVelocityLimit: isSet(object.globalAngularVelocityLimit)
        ? globalThis.Number(object.globalAngularVelocityLimit)
        : 0,
      globalMinimumWaypointVelocity: isSet(object.globalMinimumWaypointVelocity)
        ? globalThis.Number(object.globalMinimumWaypointVelocity)
        : 0,
      takeBestEffortPhotoWhenFailing: isSet(object.takeBestEffortPhotoWhenFailing)
        ? globalThis.Boolean(object.takeBestEffortPhotoWhenFailing)
        : false,
      eoPhotoFormats: globalThis.Array.isArray(object?.eoPhotoFormats)
        ? object.eoPhotoFormats.map((e: any) => photoFormat_EnumFromJSON(e))
        : [],
      irPhotoFormats: globalThis.Array.isArray(object?.irPhotoFormats)
        ? object.irPhotoFormats.map((e: any) => photoFormat_EnumFromJSON(e))
        : [],
      eoJpegQuality: isSet(object.eoJpegQuality) ? globalThis.Number(object.eoJpegQuality) : 0,
      photoCaptureMode: isSet(object.photoCaptureMode)
        ? planSettings_PhotoCaptureModeFromJSON(object.photoCaptureMode)
        : 0,
    };
  },

  toJSON(message: PlanSettings): unknown {
    const obj: any = {};
    if (message.maxAllowedBlurPixels !== 0) {
      obj.maxAllowedBlurPixels = message.maxAllowedBlurPixels;
    }
    if (message.ignoreTranslationMotionBlurConstraint === true) {
      obj.ignoreTranslationMotionBlurConstraint = message.ignoreTranslationMotionBlurConstraint;
    }
    if (message.globalVelocityLimit !== 0) {
      obj.globalVelocityLimit = message.globalVelocityLimit;
    }
    if (message.globalAngularVelocityLimit !== 0) {
      obj.globalAngularVelocityLimit = message.globalAngularVelocityLimit;
    }
    if (message.globalMinimumWaypointVelocity !== 0) {
      obj.globalMinimumWaypointVelocity = message.globalMinimumWaypointVelocity;
    }
    if (message.takeBestEffortPhotoWhenFailing === true) {
      obj.takeBestEffortPhotoWhenFailing = message.takeBestEffortPhotoWhenFailing;
    }
    if (message.eoPhotoFormats?.length) {
      obj.eoPhotoFormats = message.eoPhotoFormats.map((e) => photoFormat_EnumToJSON(e));
    }
    if (message.irPhotoFormats?.length) {
      obj.irPhotoFormats = message.irPhotoFormats.map((e) => photoFormat_EnumToJSON(e));
    }
    if (message.eoJpegQuality !== 0) {
      obj.eoJpegQuality = Math.round(message.eoJpegQuality);
    }
    if (message.photoCaptureMode !== 0) {
      obj.photoCaptureMode = planSettings_PhotoCaptureModeToJSON(message.photoCaptureMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanSettings>, I>>(base?: I): PlanSettings {
    return PlanSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanSettings>, I>>(object: I): PlanSettings {
    const message = createBasePlanSettings();
    message.maxAllowedBlurPixels = object.maxAllowedBlurPixels ?? 0;
    message.ignoreTranslationMotionBlurConstraint = object.ignoreTranslationMotionBlurConstraint ?? false;
    message.globalVelocityLimit = object.globalVelocityLimit ?? 0;
    message.globalAngularVelocityLimit = object.globalAngularVelocityLimit ?? 0;
    message.globalMinimumWaypointVelocity = object.globalMinimumWaypointVelocity ?? 0;
    message.takeBestEffortPhotoWhenFailing = object.takeBestEffortPhotoWhenFailing ?? false;
    message.eoPhotoFormats = object.eoPhotoFormats?.map((e) => e) || [];
    message.irPhotoFormats = object.irPhotoFormats?.map((e) => e) || [];
    message.eoJpegQuality = object.eoJpegQuality ?? 0;
    message.photoCaptureMode = object.photoCaptureMode ?? 0;
    return message;
  },
};

function createBasePlanRequest(): PlanRequest {
  return { utime: 0, uuid: undefined, settings: undefined, waypoints: [], frame: 0, globalMapSource: 0 };
}

export const PlanRequest = {
  encode(message: PlanRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.uuid !== undefined) {
      Uuid.encode(message.uuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.settings !== undefined) {
      PlanSettings.encode(message.settings, writer.uint32(26).fork()).ldelim();
    }
    for (const v of message.waypoints) {
      PlanWaypoint.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.frame !== 0) {
      writer.uint32(48).int32(message.frame);
    }
    if (message.globalMapSource !== 0) {
      writer.uint32(40).int32(message.globalMapSource);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlanRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.uuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.settings = PlanSettings.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.waypoints.push(PlanWaypoint.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.frame = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.globalMapSource = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanRequest {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      uuid: isSet(object.uuid) ? Uuid.fromJSON(object.uuid) : undefined,
      settings: isSet(object.settings) ? PlanSettings.fromJSON(object.settings) : undefined,
      waypoints: globalThis.Array.isArray(object?.waypoints)
        ? object.waypoints.map((e: any) => PlanWaypoint.fromJSON(e))
        : [],
      frame: isSet(object.frame) ? frameType_EnumFromJSON(object.frame) : 0,
      globalMapSource: isSet(object.globalMapSource) ? planRequest_GlobalMapSourceFromJSON(object.globalMapSource) : 0,
    };
  },

  toJSON(message: PlanRequest): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.uuid !== undefined) {
      obj.uuid = Uuid.toJSON(message.uuid);
    }
    if (message.settings !== undefined) {
      obj.settings = PlanSettings.toJSON(message.settings);
    }
    if (message.waypoints?.length) {
      obj.waypoints = message.waypoints.map((e) => PlanWaypoint.toJSON(e));
    }
    if (message.frame !== 0) {
      obj.frame = frameType_EnumToJSON(message.frame);
    }
    if (message.globalMapSource !== 0) {
      obj.globalMapSource = planRequest_GlobalMapSourceToJSON(message.globalMapSource);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanRequest>, I>>(base?: I): PlanRequest {
    return PlanRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanRequest>, I>>(object: I): PlanRequest {
    const message = createBasePlanRequest();
    message.utime = object.utime ?? 0;
    message.uuid = (object.uuid !== undefined && object.uuid !== null) ? Uuid.fromPartial(object.uuid) : undefined;
    message.settings = (object.settings !== undefined && object.settings !== null)
      ? PlanSettings.fromPartial(object.settings)
      : undefined;
    message.waypoints = object.waypoints?.map((e) => PlanWaypoint.fromPartial(e)) || [];
    message.frame = object.frame ?? 0;
    message.globalMapSource = object.globalMapSource ?? 0;
    return message;
  },
};

function createBasePhotoCapture(): PhotoCapture {
  return {
    waypointUuid: undefined,
    result: 0,
    userCameraResult: 0,
    photoWaypoint: undefined,
    referenceTPhotoRDF: undefined,
    photoFilePath: "",
    photoType: 0,
    format: 0,
    mediaId: "",
    photoCaptureUtime: 0,
    gimbalImuTWaypointRDF: undefined,
    gimbalImuStartExpositionTGimbalImuEndExpositionRDF: undefined,
    exposureTimeS: 0,
    captureSurfacePixelsTravelled: 0,
    gimbalImuLinearVelocityLimit: 0,
    gimbalImuAngularVelocityLimit: 0,
    stopAtWaypoint: false,
    stopAtWaypointReason: 0,
    minVehicleToGimbalPitch: 0,
    maxGimbalRoll: 0,
    maxGimbalRollRate: 0,
    ispPhotoRequestUtime: 0,
    ispPhotoCaptureUtime: 0,
    ispInProgressExposedUtime: 0,
    ispReadyForNextUtime: 0,
    ispCaptureSuccessfulUtime: 0,
    ispCaptureFailedUtime: 0,
    focusConvergenceTimeS: 0,
    focusStateAtEnqueue: 0,
  };
}

export const PhotoCapture = {
  encode(message: PhotoCapture, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypointUuid !== undefined) {
      Uuid.encode(message.waypointUuid, writer.uint32(10).fork()).ldelim();
    }
    if (message.result !== 0) {
      writer.uint32(16).int32(message.result);
    }
    if (message.userCameraResult !== 0) {
      writer.uint32(24).int32(message.userCameraResult);
    }
    if (message.photoWaypoint !== undefined) {
      PlanWaypoint.encode(message.photoWaypoint, writer.uint32(34).fork()).ldelim();
    }
    if (message.referenceTPhotoRDF !== undefined) {
      TransPb.encode(message.referenceTPhotoRDF, writer.uint32(154).fork()).ldelim();
    }
    if (message.photoFilePath !== "") {
      writer.uint32(114).string(message.photoFilePath);
    }
    if (message.photoType !== 0) {
      writer.uint32(120).int32(message.photoType);
    }
    if (message.format !== 0) {
      writer.uint32(128).int32(message.format);
    }
    if (message.mediaId !== "") {
      writer.uint32(138).string(message.mediaId);
    }
    if (message.photoCaptureUtime !== 0) {
      writer.uint32(144).int64(message.photoCaptureUtime);
    }
    if (message.gimbalImuTWaypointRDF !== undefined) {
      TransPb.encode(message.gimbalImuTWaypointRDF, writer.uint32(162).fork()).ldelim();
    }
    if (message.gimbalImuStartExpositionTGimbalImuEndExpositionRDF !== undefined) {
      TransPb.encode(message.gimbalImuStartExpositionTGimbalImuEndExpositionRDF, writer.uint32(194).fork()).ldelim();
    }
    if (message.exposureTimeS !== 0) {
      writer.uint32(185).double(message.exposureTimeS);
    }
    if (message.captureSurfacePixelsTravelled !== 0) {
      writer.uint32(201).double(message.captureSurfacePixelsTravelled);
    }
    if (message.gimbalImuLinearVelocityLimit !== 0) {
      writer.uint32(169).double(message.gimbalImuLinearVelocityLimit);
    }
    if (message.gimbalImuAngularVelocityLimit !== 0) {
      writer.uint32(177).double(message.gimbalImuAngularVelocityLimit);
    }
    if (message.stopAtWaypoint === true) {
      writer.uint32(208).bool(message.stopAtWaypoint);
    }
    if (message.stopAtWaypointReason !== 0) {
      writer.uint32(280).int32(message.stopAtWaypointReason);
    }
    if (message.minVehicleToGimbalPitch !== 0) {
      writer.uint32(217).double(message.minVehicleToGimbalPitch);
    }
    if (message.maxGimbalRoll !== 0) {
      writer.uint32(273).double(message.maxGimbalRoll);
    }
    if (message.maxGimbalRollRate !== 0) {
      writer.uint32(225).double(message.maxGimbalRollRate);
    }
    if (message.ispPhotoRequestUtime !== 0) {
      writer.uint32(288).int64(message.ispPhotoRequestUtime);
    }
    if (message.ispPhotoCaptureUtime !== 0) {
      writer.uint32(232).int64(message.ispPhotoCaptureUtime);
    }
    if (message.ispInProgressExposedUtime !== 0) {
      writer.uint32(240).int64(message.ispInProgressExposedUtime);
    }
    if (message.ispReadyForNextUtime !== 0) {
      writer.uint32(248).int64(message.ispReadyForNextUtime);
    }
    if (message.ispCaptureSuccessfulUtime !== 0) {
      writer.uint32(256).int64(message.ispCaptureSuccessfulUtime);
    }
    if (message.ispCaptureFailedUtime !== 0) {
      writer.uint32(264).int64(message.ispCaptureFailedUtime);
    }
    if (message.focusConvergenceTimeS !== 0) {
      writer.uint32(297).double(message.focusConvergenceTimeS);
    }
    if (message.focusStateAtEnqueue !== 0) {
      writer.uint32(304).int32(message.focusStateAtEnqueue);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoCapture {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoCapture();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypointUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.result = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.userCameraResult = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.photoWaypoint = PlanWaypoint.decode(reader, reader.uint32());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.referenceTPhotoRDF = TransPb.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.photoFilePath = reader.string();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.photoType = reader.int32() as any;
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.format = reader.int32() as any;
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.mediaId = reader.string();
          continue;
        case 18:
          if (tag !== 144) {
            break;
          }

          message.photoCaptureUtime = longToNumber(reader.int64() as Long);
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.gimbalImuTWaypointRDF = TransPb.decode(reader, reader.uint32());
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.gimbalImuStartExpositionTGimbalImuEndExpositionRDF = TransPb.decode(reader, reader.uint32());
          continue;
        case 23:
          if (tag !== 185) {
            break;
          }

          message.exposureTimeS = reader.double();
          continue;
        case 25:
          if (tag !== 201) {
            break;
          }

          message.captureSurfacePixelsTravelled = reader.double();
          continue;
        case 21:
          if (tag !== 169) {
            break;
          }

          message.gimbalImuLinearVelocityLimit = reader.double();
          continue;
        case 22:
          if (tag !== 177) {
            break;
          }

          message.gimbalImuAngularVelocityLimit = reader.double();
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.stopAtWaypoint = reader.bool();
          continue;
        case 35:
          if (tag !== 280) {
            break;
          }

          message.stopAtWaypointReason = reader.int32() as any;
          continue;
        case 27:
          if (tag !== 217) {
            break;
          }

          message.minVehicleToGimbalPitch = reader.double();
          continue;
        case 34:
          if (tag !== 273) {
            break;
          }

          message.maxGimbalRoll = reader.double();
          continue;
        case 28:
          if (tag !== 225) {
            break;
          }

          message.maxGimbalRollRate = reader.double();
          continue;
        case 36:
          if (tag !== 288) {
            break;
          }

          message.ispPhotoRequestUtime = longToNumber(reader.int64() as Long);
          continue;
        case 29:
          if (tag !== 232) {
            break;
          }

          message.ispPhotoCaptureUtime = longToNumber(reader.int64() as Long);
          continue;
        case 30:
          if (tag !== 240) {
            break;
          }

          message.ispInProgressExposedUtime = longToNumber(reader.int64() as Long);
          continue;
        case 31:
          if (tag !== 248) {
            break;
          }

          message.ispReadyForNextUtime = longToNumber(reader.int64() as Long);
          continue;
        case 32:
          if (tag !== 256) {
            break;
          }

          message.ispCaptureSuccessfulUtime = longToNumber(reader.int64() as Long);
          continue;
        case 33:
          if (tag !== 264) {
            break;
          }

          message.ispCaptureFailedUtime = longToNumber(reader.int64() as Long);
          continue;
        case 37:
          if (tag !== 297) {
            break;
          }

          message.focusConvergenceTimeS = reader.double();
          continue;
        case 38:
          if (tag !== 304) {
            break;
          }

          message.focusStateAtEnqueue = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PhotoCapture {
    return {
      waypointUuid: isSet(object.waypointUuid) ? Uuid.fromJSON(object.waypointUuid) : undefined,
      result: isSet(object.result) ? photoCapture_ResultFromJSON(object.result) : 0,
      userCameraResult: isSet(object.userCameraResult) ? photoCaptureResult_EnumFromJSON(object.userCameraResult) : 0,
      photoWaypoint: isSet(object.photoWaypoint) ? PlanWaypoint.fromJSON(object.photoWaypoint) : undefined,
      referenceTPhotoRDF: isSet(object.referenceTPhotoRDF) ? TransPb.fromJSON(object.referenceTPhotoRDF) : undefined,
      photoFilePath: isSet(object.photoFilePath) ? globalThis.String(object.photoFilePath) : "",
      photoType: isSet(object.photoType) ? photoCapture_PhotoTypeFromJSON(object.photoType) : 0,
      format: isSet(object.format) ? photoFormat_EnumFromJSON(object.format) : 0,
      mediaId: isSet(object.mediaId) ? globalThis.String(object.mediaId) : "",
      photoCaptureUtime: isSet(object.photoCaptureUtime) ? globalThis.Number(object.photoCaptureUtime) : 0,
      gimbalImuTWaypointRDF: isSet(object.gimbalImuTWaypointRDF)
        ? TransPb.fromJSON(object.gimbalImuTWaypointRDF)
        : undefined,
      gimbalImuStartExpositionTGimbalImuEndExpositionRDF:
        isSet(object.gimbalImuStartExpositionTGimbalImuEndExpositionRDF)
          ? TransPb.fromJSON(object.gimbalImuStartExpositionTGimbalImuEndExpositionRDF)
          : undefined,
      exposureTimeS: isSet(object.exposureTimeS) ? globalThis.Number(object.exposureTimeS) : 0,
      captureSurfacePixelsTravelled: isSet(object.captureSurfacePixelsTravelled)
        ? globalThis.Number(object.captureSurfacePixelsTravelled)
        : 0,
      gimbalImuLinearVelocityLimit: isSet(object.gimbalImuLinearVelocityLimit)
        ? globalThis.Number(object.gimbalImuLinearVelocityLimit)
        : 0,
      gimbalImuAngularVelocityLimit: isSet(object.gimbalImuAngularVelocityLimit)
        ? globalThis.Number(object.gimbalImuAngularVelocityLimit)
        : 0,
      stopAtWaypoint: isSet(object.stopAtWaypoint) ? globalThis.Boolean(object.stopAtWaypoint) : false,
      stopAtWaypointReason: isSet(object.stopAtWaypointReason)
        ? stopAtWaypointReasonFromJSON(object.stopAtWaypointReason)
        : 0,
      minVehicleToGimbalPitch: isSet(object.minVehicleToGimbalPitch)
        ? globalThis.Number(object.minVehicleToGimbalPitch)
        : 0,
      maxGimbalRoll: isSet(object.maxGimbalRoll) ? globalThis.Number(object.maxGimbalRoll) : 0,
      maxGimbalRollRate: isSet(object.maxGimbalRollRate) ? globalThis.Number(object.maxGimbalRollRate) : 0,
      ispPhotoRequestUtime: isSet(object.ispPhotoRequestUtime) ? globalThis.Number(object.ispPhotoRequestUtime) : 0,
      ispPhotoCaptureUtime: isSet(object.ispPhotoCaptureUtime) ? globalThis.Number(object.ispPhotoCaptureUtime) : 0,
      ispInProgressExposedUtime: isSet(object.ispInProgressExposedUtime)
        ? globalThis.Number(object.ispInProgressExposedUtime)
        : 0,
      ispReadyForNextUtime: isSet(object.ispReadyForNextUtime) ? globalThis.Number(object.ispReadyForNextUtime) : 0,
      ispCaptureSuccessfulUtime: isSet(object.ispCaptureSuccessfulUtime)
        ? globalThis.Number(object.ispCaptureSuccessfulUtime)
        : 0,
      ispCaptureFailedUtime: isSet(object.ispCaptureFailedUtime) ? globalThis.Number(object.ispCaptureFailedUtime) : 0,
      focusConvergenceTimeS: isSet(object.focusConvergenceTimeS) ? globalThis.Number(object.focusConvergenceTimeS) : 0,
      focusStateAtEnqueue: isSet(object.focusStateAtEnqueue) ? focusStateFromJSON(object.focusStateAtEnqueue) : 0,
    };
  },

  toJSON(message: PhotoCapture): unknown {
    const obj: any = {};
    if (message.waypointUuid !== undefined) {
      obj.waypointUuid = Uuid.toJSON(message.waypointUuid);
    }
    if (message.result !== 0) {
      obj.result = photoCapture_ResultToJSON(message.result);
    }
    if (message.userCameraResult !== 0) {
      obj.userCameraResult = photoCaptureResult_EnumToJSON(message.userCameraResult);
    }
    if (message.photoWaypoint !== undefined) {
      obj.photoWaypoint = PlanWaypoint.toJSON(message.photoWaypoint);
    }
    if (message.referenceTPhotoRDF !== undefined) {
      obj.referenceTPhotoRDF = TransPb.toJSON(message.referenceTPhotoRDF);
    }
    if (message.photoFilePath !== "") {
      obj.photoFilePath = message.photoFilePath;
    }
    if (message.photoType !== 0) {
      obj.photoType = photoCapture_PhotoTypeToJSON(message.photoType);
    }
    if (message.format !== 0) {
      obj.format = photoFormat_EnumToJSON(message.format);
    }
    if (message.mediaId !== "") {
      obj.mediaId = message.mediaId;
    }
    if (message.photoCaptureUtime !== 0) {
      obj.photoCaptureUtime = Math.round(message.photoCaptureUtime);
    }
    if (message.gimbalImuTWaypointRDF !== undefined) {
      obj.gimbalImuTWaypointRDF = TransPb.toJSON(message.gimbalImuTWaypointRDF);
    }
    if (message.gimbalImuStartExpositionTGimbalImuEndExpositionRDF !== undefined) {
      obj.gimbalImuStartExpositionTGimbalImuEndExpositionRDF = TransPb.toJSON(
        message.gimbalImuStartExpositionTGimbalImuEndExpositionRDF,
      );
    }
    if (message.exposureTimeS !== 0) {
      obj.exposureTimeS = message.exposureTimeS;
    }
    if (message.captureSurfacePixelsTravelled !== 0) {
      obj.captureSurfacePixelsTravelled = message.captureSurfacePixelsTravelled;
    }
    if (message.gimbalImuLinearVelocityLimit !== 0) {
      obj.gimbalImuLinearVelocityLimit = message.gimbalImuLinearVelocityLimit;
    }
    if (message.gimbalImuAngularVelocityLimit !== 0) {
      obj.gimbalImuAngularVelocityLimit = message.gimbalImuAngularVelocityLimit;
    }
    if (message.stopAtWaypoint === true) {
      obj.stopAtWaypoint = message.stopAtWaypoint;
    }
    if (message.stopAtWaypointReason !== 0) {
      obj.stopAtWaypointReason = stopAtWaypointReasonToJSON(message.stopAtWaypointReason);
    }
    if (message.minVehicleToGimbalPitch !== 0) {
      obj.minVehicleToGimbalPitch = message.minVehicleToGimbalPitch;
    }
    if (message.maxGimbalRoll !== 0) {
      obj.maxGimbalRoll = message.maxGimbalRoll;
    }
    if (message.maxGimbalRollRate !== 0) {
      obj.maxGimbalRollRate = message.maxGimbalRollRate;
    }
    if (message.ispPhotoRequestUtime !== 0) {
      obj.ispPhotoRequestUtime = Math.round(message.ispPhotoRequestUtime);
    }
    if (message.ispPhotoCaptureUtime !== 0) {
      obj.ispPhotoCaptureUtime = Math.round(message.ispPhotoCaptureUtime);
    }
    if (message.ispInProgressExposedUtime !== 0) {
      obj.ispInProgressExposedUtime = Math.round(message.ispInProgressExposedUtime);
    }
    if (message.ispReadyForNextUtime !== 0) {
      obj.ispReadyForNextUtime = Math.round(message.ispReadyForNextUtime);
    }
    if (message.ispCaptureSuccessfulUtime !== 0) {
      obj.ispCaptureSuccessfulUtime = Math.round(message.ispCaptureSuccessfulUtime);
    }
    if (message.ispCaptureFailedUtime !== 0) {
      obj.ispCaptureFailedUtime = Math.round(message.ispCaptureFailedUtime);
    }
    if (message.focusConvergenceTimeS !== 0) {
      obj.focusConvergenceTimeS = message.focusConvergenceTimeS;
    }
    if (message.focusStateAtEnqueue !== 0) {
      obj.focusStateAtEnqueue = focusStateToJSON(message.focusStateAtEnqueue);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoCapture>, I>>(base?: I): PhotoCapture {
    return PhotoCapture.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoCapture>, I>>(object: I): PhotoCapture {
    const message = createBasePhotoCapture();
    message.waypointUuid = (object.waypointUuid !== undefined && object.waypointUuid !== null)
      ? Uuid.fromPartial(object.waypointUuid)
      : undefined;
    message.result = object.result ?? 0;
    message.userCameraResult = object.userCameraResult ?? 0;
    message.photoWaypoint = (object.photoWaypoint !== undefined && object.photoWaypoint !== null)
      ? PlanWaypoint.fromPartial(object.photoWaypoint)
      : undefined;
    message.referenceTPhotoRDF = (object.referenceTPhotoRDF !== undefined && object.referenceTPhotoRDF !== null)
      ? TransPb.fromPartial(object.referenceTPhotoRDF)
      : undefined;
    message.photoFilePath = object.photoFilePath ?? "";
    message.photoType = object.photoType ?? 0;
    message.format = object.format ?? 0;
    message.mediaId = object.mediaId ?? "";
    message.photoCaptureUtime = object.photoCaptureUtime ?? 0;
    message.gimbalImuTWaypointRDF =
      (object.gimbalImuTWaypointRDF !== undefined && object.gimbalImuTWaypointRDF !== null)
        ? TransPb.fromPartial(object.gimbalImuTWaypointRDF)
        : undefined;
    message.gimbalImuStartExpositionTGimbalImuEndExpositionRDF =
      (object.gimbalImuStartExpositionTGimbalImuEndExpositionRDF !== undefined &&
          object.gimbalImuStartExpositionTGimbalImuEndExpositionRDF !== null)
        ? TransPb.fromPartial(object.gimbalImuStartExpositionTGimbalImuEndExpositionRDF)
        : undefined;
    message.exposureTimeS = object.exposureTimeS ?? 0;
    message.captureSurfacePixelsTravelled = object.captureSurfacePixelsTravelled ?? 0;
    message.gimbalImuLinearVelocityLimit = object.gimbalImuLinearVelocityLimit ?? 0;
    message.gimbalImuAngularVelocityLimit = object.gimbalImuAngularVelocityLimit ?? 0;
    message.stopAtWaypoint = object.stopAtWaypoint ?? false;
    message.stopAtWaypointReason = object.stopAtWaypointReason ?? 0;
    message.minVehicleToGimbalPitch = object.minVehicleToGimbalPitch ?? 0;
    message.maxGimbalRoll = object.maxGimbalRoll ?? 0;
    message.maxGimbalRollRate = object.maxGimbalRollRate ?? 0;
    message.ispPhotoRequestUtime = object.ispPhotoRequestUtime ?? 0;
    message.ispPhotoCaptureUtime = object.ispPhotoCaptureUtime ?? 0;
    message.ispInProgressExposedUtime = object.ispInProgressExposedUtime ?? 0;
    message.ispReadyForNextUtime = object.ispReadyForNextUtime ?? 0;
    message.ispCaptureSuccessfulUtime = object.ispCaptureSuccessfulUtime ?? 0;
    message.ispCaptureFailedUtime = object.ispCaptureFailedUtime ?? 0;
    message.focusConvergenceTimeS = object.focusConvergenceTimeS ?? 0;
    message.focusStateAtEnqueue = object.focusStateAtEnqueue ?? 0;
    return message;
  },
};

function createBaseCompletedWaypoint(): CompletedWaypoint {
  return { utime: 0, waypointUuid: undefined, result: 0 };
}

export const CompletedWaypoint = {
  encode(message: CompletedWaypoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.waypointUuid !== undefined) {
      Uuid.encode(message.waypointUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.result !== 0) {
      writer.uint32(24).int32(message.result);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CompletedWaypoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompletedWaypoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.waypointUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.result = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CompletedWaypoint {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      waypointUuid: isSet(object.waypointUuid) ? Uuid.fromJSON(object.waypointUuid) : undefined,
      result: isSet(object.result) ? completedWaypoint_ResultFromJSON(object.result) : 0,
    };
  },

  toJSON(message: CompletedWaypoint): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.waypointUuid !== undefined) {
      obj.waypointUuid = Uuid.toJSON(message.waypointUuid);
    }
    if (message.result !== 0) {
      obj.result = completedWaypoint_ResultToJSON(message.result);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CompletedWaypoint>, I>>(base?: I): CompletedWaypoint {
    return CompletedWaypoint.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompletedWaypoint>, I>>(object: I): CompletedWaypoint {
    const message = createBaseCompletedWaypoint();
    message.utime = object.utime ?? 0;
    message.waypointUuid = (object.waypointUuid !== undefined && object.waypointUuid !== null)
      ? Uuid.fromPartial(object.waypointUuid)
      : undefined;
    message.result = object.result ?? 0;
    return message;
  },
};

function createBasePlanProgress(): PlanProgress {
  return {
    utime: 0,
    planUuid: undefined,
    isComplete: false,
    completedWaypoints: [],
    photoCaptures: [],
    estimatedTimeToCompletionS: 0,
  };
}

export const PlanProgress = {
  encode(message: PlanProgress, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.planUuid !== undefined) {
      Uuid.encode(message.planUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.isComplete === true) {
      writer.uint32(24).bool(message.isComplete);
    }
    for (const v of message.completedWaypoints) {
      CompletedWaypoint.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    for (const v of message.photoCaptures) {
      PhotoCapture.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    if (message.estimatedTimeToCompletionS !== 0) {
      writer.uint32(53).float(message.estimatedTimeToCompletionS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PlanProgress {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePlanProgress();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.planUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.isComplete = reader.bool();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.completedWaypoints.push(CompletedWaypoint.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.photoCaptures.push(PhotoCapture.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.estimatedTimeToCompletionS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PlanProgress {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      planUuid: isSet(object.planUuid) ? Uuid.fromJSON(object.planUuid) : undefined,
      isComplete: isSet(object.isComplete) ? globalThis.Boolean(object.isComplete) : false,
      completedWaypoints: globalThis.Array.isArray(object?.completedWaypoints)
        ? object.completedWaypoints.map((e: any) => CompletedWaypoint.fromJSON(e))
        : [],
      photoCaptures: globalThis.Array.isArray(object?.photoCaptures)
        ? object.photoCaptures.map((e: any) => PhotoCapture.fromJSON(e))
        : [],
      estimatedTimeToCompletionS: isSet(object.estimatedTimeToCompletionS)
        ? globalThis.Number(object.estimatedTimeToCompletionS)
        : 0,
    };
  },

  toJSON(message: PlanProgress): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.planUuid !== undefined) {
      obj.planUuid = Uuid.toJSON(message.planUuid);
    }
    if (message.isComplete === true) {
      obj.isComplete = message.isComplete;
    }
    if (message.completedWaypoints?.length) {
      obj.completedWaypoints = message.completedWaypoints.map((e) => CompletedWaypoint.toJSON(e));
    }
    if (message.photoCaptures?.length) {
      obj.photoCaptures = message.photoCaptures.map((e) => PhotoCapture.toJSON(e));
    }
    if (message.estimatedTimeToCompletionS !== 0) {
      obj.estimatedTimeToCompletionS = message.estimatedTimeToCompletionS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PlanProgress>, I>>(base?: I): PlanProgress {
    return PlanProgress.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PlanProgress>, I>>(object: I): PlanProgress {
    const message = createBasePlanProgress();
    message.utime = object.utime ?? 0;
    message.planUuid = (object.planUuid !== undefined && object.planUuid !== null)
      ? Uuid.fromPartial(object.planUuid)
      : undefined;
    message.isComplete = object.isComplete ?? false;
    message.completedWaypoints = object.completedWaypoints?.map((e) => CompletedWaypoint.fromPartial(e)) || [];
    message.photoCaptures = object.photoCaptures?.map((e) => PhotoCapture.fromPartial(e)) || [];
    message.estimatedTimeToCompletionS = object.estimatedTimeToCompletionS ?? 0;
    return message;
  },
};

function createBaseWaypointStateDebug(): WaypointStateDebug {
  return {
    waypoint: undefined,
    isPhotoWaypoint: false,
    stopAtWaypoint: false,
    stopAtWaypointReason: 0,
    stopAtWaypointTimeoutStartUtime: 0,
    estimatedTimeToReachWaypoint: 0,
    requiresGimbalFlip: false,
    poseFrozen: false,
    isStuck: false,
    largeTrajectoryDeflection: false,
    focusTimeoutStartUtime: 0,
    focusTimeoutEndUtime: 0,
    focusState: 0,
  };
}

export const WaypointStateDebug = {
  encode(message: WaypointStateDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.waypoint !== undefined) {
      PlanWaypoint.encode(message.waypoint, writer.uint32(10).fork()).ldelim();
    }
    if (message.isPhotoWaypoint === true) {
      writer.uint32(16).bool(message.isPhotoWaypoint);
    }
    if (message.stopAtWaypoint === true) {
      writer.uint32(24).bool(message.stopAtWaypoint);
    }
    if (message.stopAtWaypointReason !== 0) {
      writer.uint32(104).int32(message.stopAtWaypointReason);
    }
    if (message.stopAtWaypointTimeoutStartUtime !== 0) {
      writer.uint32(32).uint64(message.stopAtWaypointTimeoutStartUtime);
    }
    if (message.estimatedTimeToReachWaypoint !== 0) {
      writer.uint32(65).double(message.estimatedTimeToReachWaypoint);
    }
    if (message.requiresGimbalFlip === true) {
      writer.uint32(72).bool(message.requiresGimbalFlip);
    }
    if (message.poseFrozen === true) {
      writer.uint32(80).bool(message.poseFrozen);
    }
    if (message.isStuck === true) {
      writer.uint32(88).bool(message.isStuck);
    }
    if (message.largeTrajectoryDeflection === true) {
      writer.uint32(96).bool(message.largeTrajectoryDeflection);
    }
    if (message.focusTimeoutStartUtime !== 0) {
      writer.uint32(112).uint64(message.focusTimeoutStartUtime);
    }
    if (message.focusTimeoutEndUtime !== 0) {
      writer.uint32(120).uint64(message.focusTimeoutEndUtime);
    }
    if (message.focusState !== 0) {
      writer.uint32(128).int32(message.focusState);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaypointStateDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypointStateDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.waypoint = PlanWaypoint.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.isPhotoWaypoint = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.stopAtWaypoint = reader.bool();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.stopAtWaypointReason = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.stopAtWaypointTimeoutStartUtime = longToNumber(reader.uint64() as Long);
          continue;
        case 8:
          if (tag !== 65) {
            break;
          }

          message.estimatedTimeToReachWaypoint = reader.double();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.requiresGimbalFlip = reader.bool();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.poseFrozen = reader.bool();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.isStuck = reader.bool();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.largeTrajectoryDeflection = reader.bool();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.focusTimeoutStartUtime = longToNumber(reader.uint64() as Long);
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.focusTimeoutEndUtime = longToNumber(reader.uint64() as Long);
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.focusState = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaypointStateDebug {
    return {
      waypoint: isSet(object.waypoint) ? PlanWaypoint.fromJSON(object.waypoint) : undefined,
      isPhotoWaypoint: isSet(object.isPhotoWaypoint) ? globalThis.Boolean(object.isPhotoWaypoint) : false,
      stopAtWaypoint: isSet(object.stopAtWaypoint) ? globalThis.Boolean(object.stopAtWaypoint) : false,
      stopAtWaypointReason: isSet(object.stopAtWaypointReason)
        ? stopAtWaypointReasonFromJSON(object.stopAtWaypointReason)
        : 0,
      stopAtWaypointTimeoutStartUtime: isSet(object.stopAtWaypointTimeoutStartUtime)
        ? globalThis.Number(object.stopAtWaypointTimeoutStartUtime)
        : 0,
      estimatedTimeToReachWaypoint: isSet(object.estimatedTimeToReachWaypoint)
        ? globalThis.Number(object.estimatedTimeToReachWaypoint)
        : 0,
      requiresGimbalFlip: isSet(object.requiresGimbalFlip) ? globalThis.Boolean(object.requiresGimbalFlip) : false,
      poseFrozen: isSet(object.poseFrozen) ? globalThis.Boolean(object.poseFrozen) : false,
      isStuck: isSet(object.isStuck) ? globalThis.Boolean(object.isStuck) : false,
      largeTrajectoryDeflection: isSet(object.largeTrajectoryDeflection)
        ? globalThis.Boolean(object.largeTrajectoryDeflection)
        : false,
      focusTimeoutStartUtime: isSet(object.focusTimeoutStartUtime)
        ? globalThis.Number(object.focusTimeoutStartUtime)
        : 0,
      focusTimeoutEndUtime: isSet(object.focusTimeoutEndUtime) ? globalThis.Number(object.focusTimeoutEndUtime) : 0,
      focusState: isSet(object.focusState) ? focusStateFromJSON(object.focusState) : 0,
    };
  },

  toJSON(message: WaypointStateDebug): unknown {
    const obj: any = {};
    if (message.waypoint !== undefined) {
      obj.waypoint = PlanWaypoint.toJSON(message.waypoint);
    }
    if (message.isPhotoWaypoint === true) {
      obj.isPhotoWaypoint = message.isPhotoWaypoint;
    }
    if (message.stopAtWaypoint === true) {
      obj.stopAtWaypoint = message.stopAtWaypoint;
    }
    if (message.stopAtWaypointReason !== 0) {
      obj.stopAtWaypointReason = stopAtWaypointReasonToJSON(message.stopAtWaypointReason);
    }
    if (message.stopAtWaypointTimeoutStartUtime !== 0) {
      obj.stopAtWaypointTimeoutStartUtime = Math.round(message.stopAtWaypointTimeoutStartUtime);
    }
    if (message.estimatedTimeToReachWaypoint !== 0) {
      obj.estimatedTimeToReachWaypoint = message.estimatedTimeToReachWaypoint;
    }
    if (message.requiresGimbalFlip === true) {
      obj.requiresGimbalFlip = message.requiresGimbalFlip;
    }
    if (message.poseFrozen === true) {
      obj.poseFrozen = message.poseFrozen;
    }
    if (message.isStuck === true) {
      obj.isStuck = message.isStuck;
    }
    if (message.largeTrajectoryDeflection === true) {
      obj.largeTrajectoryDeflection = message.largeTrajectoryDeflection;
    }
    if (message.focusTimeoutStartUtime !== 0) {
      obj.focusTimeoutStartUtime = Math.round(message.focusTimeoutStartUtime);
    }
    if (message.focusTimeoutEndUtime !== 0) {
      obj.focusTimeoutEndUtime = Math.round(message.focusTimeoutEndUtime);
    }
    if (message.focusState !== 0) {
      obj.focusState = focusStateToJSON(message.focusState);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaypointStateDebug>, I>>(base?: I): WaypointStateDebug {
    return WaypointStateDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaypointStateDebug>, I>>(object: I): WaypointStateDebug {
    const message = createBaseWaypointStateDebug();
    message.waypoint = (object.waypoint !== undefined && object.waypoint !== null)
      ? PlanWaypoint.fromPartial(object.waypoint)
      : undefined;
    message.isPhotoWaypoint = object.isPhotoWaypoint ?? false;
    message.stopAtWaypoint = object.stopAtWaypoint ?? false;
    message.stopAtWaypointReason = object.stopAtWaypointReason ?? 0;
    message.stopAtWaypointTimeoutStartUtime = object.stopAtWaypointTimeoutStartUtime ?? 0;
    message.estimatedTimeToReachWaypoint = object.estimatedTimeToReachWaypoint ?? 0;
    message.requiresGimbalFlip = object.requiresGimbalFlip ?? false;
    message.poseFrozen = object.poseFrozen ?? false;
    message.isStuck = object.isStuck ?? false;
    message.largeTrajectoryDeflection = object.largeTrajectoryDeflection ?? false;
    message.focusTimeoutStartUtime = object.focusTimeoutStartUtime ?? 0;
    message.focusTimeoutEndUtime = object.focusTimeoutEndUtime ?? 0;
    message.focusState = object.focusState ?? 0;
    return message;
  },
};

function createBaseStuckDetectorDebug(): StuckDetectorDebug {
  return { timeSinceMinDistanceUpdate: 0, minDistanceToWaypoint: 0 };
}

export const StuckDetectorDebug = {
  encode(message: StuckDetectorDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeSinceMinDistanceUpdate !== 0) {
      writer.uint32(9).double(message.timeSinceMinDistanceUpdate);
    }
    if (message.minDistanceToWaypoint !== 0) {
      writer.uint32(17).double(message.minDistanceToWaypoint);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StuckDetectorDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStuckDetectorDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 9) {
            break;
          }

          message.timeSinceMinDistanceUpdate = reader.double();
          continue;
        case 2:
          if (tag !== 17) {
            break;
          }

          message.minDistanceToWaypoint = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StuckDetectorDebug {
    return {
      timeSinceMinDistanceUpdate: isSet(object.timeSinceMinDistanceUpdate)
        ? globalThis.Number(object.timeSinceMinDistanceUpdate)
        : 0,
      minDistanceToWaypoint: isSet(object.minDistanceToWaypoint) ? globalThis.Number(object.minDistanceToWaypoint) : 0,
    };
  },

  toJSON(message: StuckDetectorDebug): unknown {
    const obj: any = {};
    if (message.timeSinceMinDistanceUpdate !== 0) {
      obj.timeSinceMinDistanceUpdate = message.timeSinceMinDistanceUpdate;
    }
    if (message.minDistanceToWaypoint !== 0) {
      obj.minDistanceToWaypoint = message.minDistanceToWaypoint;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StuckDetectorDebug>, I>>(base?: I): StuckDetectorDebug {
    return StuckDetectorDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StuckDetectorDebug>, I>>(object: I): StuckDetectorDebug {
    const message = createBaseStuckDetectorDebug();
    message.timeSinceMinDistanceUpdate = object.timeSinceMinDistanceUpdate ?? 0;
    message.minDistanceToWaypoint = object.minDistanceToWaypoint ?? 0;
    return message;
  },
};

function createBaseTrajectoryPlanDebug(): TrajectoryPlanDebug {
  return {
    utime: 0,
    planUuid: undefined,
    navTReference: undefined,
    stuckDetector: undefined,
    waypoints: [],
    predictedIspReadyTimeFromCurrent: 0,
  };
}

export const TrajectoryPlanDebug = {
  encode(message: TrajectoryPlanDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.planUuid !== undefined) {
      Uuid.encode(message.planUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.navTReference !== undefined) {
      TransPb.encode(message.navTReference, writer.uint32(26).fork()).ldelim();
    }
    if (message.stuckDetector !== undefined) {
      StuckDetectorDebug.encode(message.stuckDetector, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.waypoints) {
      WaypointStateDebug.encode(v!, writer.uint32(34).fork()).ldelim();
    }
    if (message.predictedIspReadyTimeFromCurrent !== 0) {
      writer.uint32(53).float(message.predictedIspReadyTimeFromCurrent);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TrajectoryPlanDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrajectoryPlanDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.planUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.navTReference = TransPb.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.stuckDetector = StuckDetectorDebug.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.waypoints.push(WaypointStateDebug.decode(reader, reader.uint32()));
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.predictedIspReadyTimeFromCurrent = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TrajectoryPlanDebug {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      planUuid: isSet(object.planUuid) ? Uuid.fromJSON(object.planUuid) : undefined,
      navTReference: isSet(object.navTReference) ? TransPb.fromJSON(object.navTReference) : undefined,
      stuckDetector: isSet(object.stuckDetector) ? StuckDetectorDebug.fromJSON(object.stuckDetector) : undefined,
      waypoints: globalThis.Array.isArray(object?.waypoints)
        ? object.waypoints.map((e: any) => WaypointStateDebug.fromJSON(e))
        : [],
      predictedIspReadyTimeFromCurrent: isSet(object.predictedIspReadyTimeFromCurrent)
        ? globalThis.Number(object.predictedIspReadyTimeFromCurrent)
        : 0,
    };
  },

  toJSON(message: TrajectoryPlanDebug): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.planUuid !== undefined) {
      obj.planUuid = Uuid.toJSON(message.planUuid);
    }
    if (message.navTReference !== undefined) {
      obj.navTReference = TransPb.toJSON(message.navTReference);
    }
    if (message.stuckDetector !== undefined) {
      obj.stuckDetector = StuckDetectorDebug.toJSON(message.stuckDetector);
    }
    if (message.waypoints?.length) {
      obj.waypoints = message.waypoints.map((e) => WaypointStateDebug.toJSON(e));
    }
    if (message.predictedIspReadyTimeFromCurrent !== 0) {
      obj.predictedIspReadyTimeFromCurrent = message.predictedIspReadyTimeFromCurrent;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TrajectoryPlanDebug>, I>>(base?: I): TrajectoryPlanDebug {
    return TrajectoryPlanDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TrajectoryPlanDebug>, I>>(object: I): TrajectoryPlanDebug {
    const message = createBaseTrajectoryPlanDebug();
    message.utime = object.utime ?? 0;
    message.planUuid = (object.planUuid !== undefined && object.planUuid !== null)
      ? Uuid.fromPartial(object.planUuid)
      : undefined;
    message.navTReference = (object.navTReference !== undefined && object.navTReference !== null)
      ? TransPb.fromPartial(object.navTReference)
      : undefined;
    message.stuckDetector = (object.stuckDetector !== undefined && object.stuckDetector !== null)
      ? StuckDetectorDebug.fromPartial(object.stuckDetector)
      : undefined;
    message.waypoints = object.waypoints?.map((e) => WaypointStateDebug.fromPartial(e)) || [];
    message.predictedIspReadyTimeFromCurrent = object.predictedIspReadyTimeFromCurrent ?? 0;
    return message;
  },
};

function createBaseWaypointVelocityLimitsDebug(): WaypointVelocityLimitsDebug {
  return { pathVelocityLimit: 0, linearVelocityLimit: 0, angularVelocityLimit: 0 };
}

export const WaypointVelocityLimitsDebug = {
  encode(message: WaypointVelocityLimitsDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pathVelocityLimit !== 0) {
      writer.uint32(13).float(message.pathVelocityLimit);
    }
    if (message.linearVelocityLimit !== 0) {
      writer.uint32(21).float(message.linearVelocityLimit);
    }
    if (message.angularVelocityLimit !== 0) {
      writer.uint32(29).float(message.angularVelocityLimit);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): WaypointVelocityLimitsDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseWaypointVelocityLimitsDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.pathVelocityLimit = reader.float();
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.linearVelocityLimit = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.angularVelocityLimit = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): WaypointVelocityLimitsDebug {
    return {
      pathVelocityLimit: isSet(object.pathVelocityLimit) ? globalThis.Number(object.pathVelocityLimit) : 0,
      linearVelocityLimit: isSet(object.linearVelocityLimit) ? globalThis.Number(object.linearVelocityLimit) : 0,
      angularVelocityLimit: isSet(object.angularVelocityLimit) ? globalThis.Number(object.angularVelocityLimit) : 0,
    };
  },

  toJSON(message: WaypointVelocityLimitsDebug): unknown {
    const obj: any = {};
    if (message.pathVelocityLimit !== 0) {
      obj.pathVelocityLimit = message.pathVelocityLimit;
    }
    if (message.linearVelocityLimit !== 0) {
      obj.linearVelocityLimit = message.linearVelocityLimit;
    }
    if (message.angularVelocityLimit !== 0) {
      obj.angularVelocityLimit = message.angularVelocityLimit;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<WaypointVelocityLimitsDebug>, I>>(base?: I): WaypointVelocityLimitsDebug {
    return WaypointVelocityLimitsDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<WaypointVelocityLimitsDebug>, I>>(object: I): WaypointVelocityLimitsDebug {
    const message = createBaseWaypointVelocityLimitsDebug();
    message.pathVelocityLimit = object.pathVelocityLimit ?? 0;
    message.linearVelocityLimit = object.linearVelocityLimit ?? 0;
    message.angularVelocityLimit = object.angularVelocityLimit ?? 0;
    return message;
  },
};

function createBaseMovementCmdDebug(): MovementCmdDebug {
  return {
    utime: 0,
    navTVehicle: undefined,
    targetWaypointUuid: undefined,
    distanceToTargetWaypointM: 0,
    timeToTargetWaypointS: 0,
    currentHeading: 0,
    currentHeadingRate: 0,
    currentPitch: 0,
    hasGimbalTarget: false,
    targetWaypointHeadingTarget: 0,
    targetWaypointHeadingDiff: 0,
    targetWaypointPitchTarget: 0,
    holdForPhoto: false,
    slowForPhoto: false,
    waypointsInWindow: 0,
    waypointUuids: [],
    waypointLimitsPhotoBlur: [],
    waypointLimitsRotateForPhoto: [],
    waypointLimitsCaptureFrequency: [],
    waypointLimitsSlowForPhoto: [],
    waypointLimitsHoldForPhoto: [],
    waypointLimitsFinal: [],
  };
}

export const MovementCmdDebug = {
  encode(message: MovementCmdDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.navTVehicle !== undefined) {
      Vector3fPb.encode(message.navTVehicle, writer.uint32(18).fork()).ldelim();
    }
    if (message.targetWaypointUuid !== undefined) {
      Uuid.encode(message.targetWaypointUuid, writer.uint32(26).fork()).ldelim();
    }
    if (message.distanceToTargetWaypointM !== 0) {
      writer.uint32(37).float(message.distanceToTargetWaypointM);
    }
    if (message.timeToTargetWaypointS !== 0) {
      writer.uint32(45).float(message.timeToTargetWaypointS);
    }
    if (message.currentHeading !== 0) {
      writer.uint32(53).float(message.currentHeading);
    }
    if (message.currentHeadingRate !== 0) {
      writer.uint32(61).float(message.currentHeadingRate);
    }
    if (message.currentPitch !== 0) {
      writer.uint32(69).float(message.currentPitch);
    }
    if (message.hasGimbalTarget === true) {
      writer.uint32(72).bool(message.hasGimbalTarget);
    }
    if (message.targetWaypointHeadingTarget !== 0) {
      writer.uint32(85).float(message.targetWaypointHeadingTarget);
    }
    if (message.targetWaypointHeadingDiff !== 0) {
      writer.uint32(93).float(message.targetWaypointHeadingDiff);
    }
    if (message.targetWaypointPitchTarget !== 0) {
      writer.uint32(101).float(message.targetWaypointPitchTarget);
    }
    if (message.holdForPhoto === true) {
      writer.uint32(104).bool(message.holdForPhoto);
    }
    if (message.slowForPhoto === true) {
      writer.uint32(112).bool(message.slowForPhoto);
    }
    if (message.waypointsInWindow !== 0) {
      writer.uint32(120).uint64(message.waypointsInWindow);
    }
    for (const v of message.waypointUuids) {
      Uuid.encode(v!, writer.uint32(130).fork()).ldelim();
    }
    for (const v of message.waypointLimitsPhotoBlur) {
      WaypointVelocityLimitsDebug.encode(v!, writer.uint32(146).fork()).ldelim();
    }
    for (const v of message.waypointLimitsRotateForPhoto) {
      WaypointVelocityLimitsDebug.encode(v!, writer.uint32(154).fork()).ldelim();
    }
    for (const v of message.waypointLimitsCaptureFrequency) {
      WaypointVelocityLimitsDebug.encode(v!, writer.uint32(162).fork()).ldelim();
    }
    for (const v of message.waypointLimitsSlowForPhoto) {
      WaypointVelocityLimitsDebug.encode(v!, writer.uint32(186).fork()).ldelim();
    }
    for (const v of message.waypointLimitsHoldForPhoto) {
      WaypointVelocityLimitsDebug.encode(v!, writer.uint32(178).fork()).ldelim();
    }
    for (const v of message.waypointLimitsFinal) {
      WaypointVelocityLimitsDebug.encode(v!, writer.uint32(194).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MovementCmdDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMovementCmdDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.navTVehicle = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.targetWaypointUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.distanceToTargetWaypointM = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.timeToTargetWaypointS = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.currentHeading = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.currentHeadingRate = reader.float();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.currentPitch = reader.float();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.hasGimbalTarget = reader.bool();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.targetWaypointHeadingTarget = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.targetWaypointHeadingDiff = reader.float();
          continue;
        case 12:
          if (tag !== 101) {
            break;
          }

          message.targetWaypointPitchTarget = reader.float();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.holdForPhoto = reader.bool();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.slowForPhoto = reader.bool();
          continue;
        case 15:
          if (tag !== 120) {
            break;
          }

          message.waypointsInWindow = longToNumber(reader.uint64() as Long);
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.waypointUuids.push(Uuid.decode(reader, reader.uint32()));
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.waypointLimitsPhotoBlur.push(WaypointVelocityLimitsDebug.decode(reader, reader.uint32()));
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.waypointLimitsRotateForPhoto.push(WaypointVelocityLimitsDebug.decode(reader, reader.uint32()));
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.waypointLimitsCaptureFrequency.push(WaypointVelocityLimitsDebug.decode(reader, reader.uint32()));
          continue;
        case 23:
          if (tag !== 186) {
            break;
          }

          message.waypointLimitsSlowForPhoto.push(WaypointVelocityLimitsDebug.decode(reader, reader.uint32()));
          continue;
        case 22:
          if (tag !== 178) {
            break;
          }

          message.waypointLimitsHoldForPhoto.push(WaypointVelocityLimitsDebug.decode(reader, reader.uint32()));
          continue;
        case 24:
          if (tag !== 194) {
            break;
          }

          message.waypointLimitsFinal.push(WaypointVelocityLimitsDebug.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MovementCmdDebug {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      navTVehicle: isSet(object.navTVehicle) ? Vector3fPb.fromJSON(object.navTVehicle) : undefined,
      targetWaypointUuid: isSet(object.targetWaypointUuid) ? Uuid.fromJSON(object.targetWaypointUuid) : undefined,
      distanceToTargetWaypointM: isSet(object.distanceToTargetWaypointM)
        ? globalThis.Number(object.distanceToTargetWaypointM)
        : 0,
      timeToTargetWaypointS: isSet(object.timeToTargetWaypointS) ? globalThis.Number(object.timeToTargetWaypointS) : 0,
      currentHeading: isSet(object.currentHeading) ? globalThis.Number(object.currentHeading) : 0,
      currentHeadingRate: isSet(object.currentHeadingRate) ? globalThis.Number(object.currentHeadingRate) : 0,
      currentPitch: isSet(object.currentPitch) ? globalThis.Number(object.currentPitch) : 0,
      hasGimbalTarget: isSet(object.hasGimbalTarget) ? globalThis.Boolean(object.hasGimbalTarget) : false,
      targetWaypointHeadingTarget: isSet(object.targetWaypointHeadingTarget)
        ? globalThis.Number(object.targetWaypointHeadingTarget)
        : 0,
      targetWaypointHeadingDiff: isSet(object.targetWaypointHeadingDiff)
        ? globalThis.Number(object.targetWaypointHeadingDiff)
        : 0,
      targetWaypointPitchTarget: isSet(object.targetWaypointPitchTarget)
        ? globalThis.Number(object.targetWaypointPitchTarget)
        : 0,
      holdForPhoto: isSet(object.holdForPhoto) ? globalThis.Boolean(object.holdForPhoto) : false,
      slowForPhoto: isSet(object.slowForPhoto) ? globalThis.Boolean(object.slowForPhoto) : false,
      waypointsInWindow: isSet(object.waypointsInWindow) ? globalThis.Number(object.waypointsInWindow) : 0,
      waypointUuids: globalThis.Array.isArray(object?.waypointUuids)
        ? object.waypointUuids.map((e: any) => Uuid.fromJSON(e))
        : [],
      waypointLimitsPhotoBlur: globalThis.Array.isArray(object?.waypointLimitsPhotoBlur)
        ? object.waypointLimitsPhotoBlur.map((e: any) => WaypointVelocityLimitsDebug.fromJSON(e))
        : [],
      waypointLimitsRotateForPhoto: globalThis.Array.isArray(object?.waypointLimitsRotateForPhoto)
        ? object.waypointLimitsRotateForPhoto.map((e: any) => WaypointVelocityLimitsDebug.fromJSON(e))
        : [],
      waypointLimitsCaptureFrequency: globalThis.Array.isArray(object?.waypointLimitsCaptureFrequency)
        ? object.waypointLimitsCaptureFrequency.map((e: any) => WaypointVelocityLimitsDebug.fromJSON(e))
        : [],
      waypointLimitsSlowForPhoto: globalThis.Array.isArray(object?.waypointLimitsSlowForPhoto)
        ? object.waypointLimitsSlowForPhoto.map((e: any) => WaypointVelocityLimitsDebug.fromJSON(e))
        : [],
      waypointLimitsHoldForPhoto: globalThis.Array.isArray(object?.waypointLimitsHoldForPhoto)
        ? object.waypointLimitsHoldForPhoto.map((e: any) => WaypointVelocityLimitsDebug.fromJSON(e))
        : [],
      waypointLimitsFinal: globalThis.Array.isArray(object?.waypointLimitsFinal)
        ? object.waypointLimitsFinal.map((e: any) => WaypointVelocityLimitsDebug.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MovementCmdDebug): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.navTVehicle !== undefined) {
      obj.navTVehicle = Vector3fPb.toJSON(message.navTVehicle);
    }
    if (message.targetWaypointUuid !== undefined) {
      obj.targetWaypointUuid = Uuid.toJSON(message.targetWaypointUuid);
    }
    if (message.distanceToTargetWaypointM !== 0) {
      obj.distanceToTargetWaypointM = message.distanceToTargetWaypointM;
    }
    if (message.timeToTargetWaypointS !== 0) {
      obj.timeToTargetWaypointS = message.timeToTargetWaypointS;
    }
    if (message.currentHeading !== 0) {
      obj.currentHeading = message.currentHeading;
    }
    if (message.currentHeadingRate !== 0) {
      obj.currentHeadingRate = message.currentHeadingRate;
    }
    if (message.currentPitch !== 0) {
      obj.currentPitch = message.currentPitch;
    }
    if (message.hasGimbalTarget === true) {
      obj.hasGimbalTarget = message.hasGimbalTarget;
    }
    if (message.targetWaypointHeadingTarget !== 0) {
      obj.targetWaypointHeadingTarget = message.targetWaypointHeadingTarget;
    }
    if (message.targetWaypointHeadingDiff !== 0) {
      obj.targetWaypointHeadingDiff = message.targetWaypointHeadingDiff;
    }
    if (message.targetWaypointPitchTarget !== 0) {
      obj.targetWaypointPitchTarget = message.targetWaypointPitchTarget;
    }
    if (message.holdForPhoto === true) {
      obj.holdForPhoto = message.holdForPhoto;
    }
    if (message.slowForPhoto === true) {
      obj.slowForPhoto = message.slowForPhoto;
    }
    if (message.waypointsInWindow !== 0) {
      obj.waypointsInWindow = Math.round(message.waypointsInWindow);
    }
    if (message.waypointUuids?.length) {
      obj.waypointUuids = message.waypointUuids.map((e) => Uuid.toJSON(e));
    }
    if (message.waypointLimitsPhotoBlur?.length) {
      obj.waypointLimitsPhotoBlur = message.waypointLimitsPhotoBlur.map((e) => WaypointVelocityLimitsDebug.toJSON(e));
    }
    if (message.waypointLimitsRotateForPhoto?.length) {
      obj.waypointLimitsRotateForPhoto = message.waypointLimitsRotateForPhoto.map((e) =>
        WaypointVelocityLimitsDebug.toJSON(e)
      );
    }
    if (message.waypointLimitsCaptureFrequency?.length) {
      obj.waypointLimitsCaptureFrequency = message.waypointLimitsCaptureFrequency.map((e) =>
        WaypointVelocityLimitsDebug.toJSON(e)
      );
    }
    if (message.waypointLimitsSlowForPhoto?.length) {
      obj.waypointLimitsSlowForPhoto = message.waypointLimitsSlowForPhoto.map((e) =>
        WaypointVelocityLimitsDebug.toJSON(e)
      );
    }
    if (message.waypointLimitsHoldForPhoto?.length) {
      obj.waypointLimitsHoldForPhoto = message.waypointLimitsHoldForPhoto.map((e) =>
        WaypointVelocityLimitsDebug.toJSON(e)
      );
    }
    if (message.waypointLimitsFinal?.length) {
      obj.waypointLimitsFinal = message.waypointLimitsFinal.map((e) => WaypointVelocityLimitsDebug.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MovementCmdDebug>, I>>(base?: I): MovementCmdDebug {
    return MovementCmdDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MovementCmdDebug>, I>>(object: I): MovementCmdDebug {
    const message = createBaseMovementCmdDebug();
    message.utime = object.utime ?? 0;
    message.navTVehicle = (object.navTVehicle !== undefined && object.navTVehicle !== null)
      ? Vector3fPb.fromPartial(object.navTVehicle)
      : undefined;
    message.targetWaypointUuid = (object.targetWaypointUuid !== undefined && object.targetWaypointUuid !== null)
      ? Uuid.fromPartial(object.targetWaypointUuid)
      : undefined;
    message.distanceToTargetWaypointM = object.distanceToTargetWaypointM ?? 0;
    message.timeToTargetWaypointS = object.timeToTargetWaypointS ?? 0;
    message.currentHeading = object.currentHeading ?? 0;
    message.currentHeadingRate = object.currentHeadingRate ?? 0;
    message.currentPitch = object.currentPitch ?? 0;
    message.hasGimbalTarget = object.hasGimbalTarget ?? false;
    message.targetWaypointHeadingTarget = object.targetWaypointHeadingTarget ?? 0;
    message.targetWaypointHeadingDiff = object.targetWaypointHeadingDiff ?? 0;
    message.targetWaypointPitchTarget = object.targetWaypointPitchTarget ?? 0;
    message.holdForPhoto = object.holdForPhoto ?? false;
    message.slowForPhoto = object.slowForPhoto ?? false;
    message.waypointsInWindow = object.waypointsInWindow ?? 0;
    message.waypointUuids = object.waypointUuids?.map((e) => Uuid.fromPartial(e)) || [];
    message.waypointLimitsPhotoBlur =
      object.waypointLimitsPhotoBlur?.map((e) => WaypointVelocityLimitsDebug.fromPartial(e)) || [];
    message.waypointLimitsRotateForPhoto =
      object.waypointLimitsRotateForPhoto?.map((e) => WaypointVelocityLimitsDebug.fromPartial(e)) || [];
    message.waypointLimitsCaptureFrequency =
      object.waypointLimitsCaptureFrequency?.map((e) => WaypointVelocityLimitsDebug.fromPartial(e)) || [];
    message.waypointLimitsSlowForPhoto =
      object.waypointLimitsSlowForPhoto?.map((e) => WaypointVelocityLimitsDebug.fromPartial(e)) || [];
    message.waypointLimitsHoldForPhoto =
      object.waypointLimitsHoldForPhoto?.map((e) => WaypointVelocityLimitsDebug.fromPartial(e)) || [];
    message.waypointLimitsFinal = object.waypointLimitsFinal?.map((e) => WaypointVelocityLimitsDebug.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseStopForPhotoDebug(): StopForPhotoDebug {
  return {
    utime: 0,
    waypointUuid: undefined,
    navTVehicle: undefined,
    navTWaypoint: undefined,
    distance: 0,
    vehiclePitch: 0,
    waypointPitch: 0,
    pitchDiff: 0,
    vehicleHeading: 0,
    waypointHeading: 0,
    headingDiff: 0,
    hasReachedWaypoint: false,
    hasReachedVelocityLimit: false,
    readyForNextPhoto: false,
    currentTimeoutDuration: 0,
    timedOut: false,
    vehicleBodyVisible: false,
  };
}

export const StopForPhotoDebug = {
  encode(message: StopForPhotoDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.waypointUuid !== undefined) {
      Uuid.encode(message.waypointUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.navTVehicle !== undefined) {
      Vector3fPb.encode(message.navTVehicle, writer.uint32(26).fork()).ldelim();
    }
    if (message.navTWaypoint !== undefined) {
      Vector3fPb.encode(message.navTWaypoint, writer.uint32(34).fork()).ldelim();
    }
    if (message.distance !== 0) {
      writer.uint32(45).float(message.distance);
    }
    if (message.vehiclePitch !== 0) {
      writer.uint32(53).float(message.vehiclePitch);
    }
    if (message.waypointPitch !== 0) {
      writer.uint32(61).float(message.waypointPitch);
    }
    if (message.pitchDiff !== 0) {
      writer.uint32(69).float(message.pitchDiff);
    }
    if (message.vehicleHeading !== 0) {
      writer.uint32(77).float(message.vehicleHeading);
    }
    if (message.waypointHeading !== 0) {
      writer.uint32(85).float(message.waypointHeading);
    }
    if (message.headingDiff !== 0) {
      writer.uint32(93).float(message.headingDiff);
    }
    if (message.hasReachedWaypoint === true) {
      writer.uint32(96).bool(message.hasReachedWaypoint);
    }
    if (message.hasReachedVelocityLimit === true) {
      writer.uint32(104).bool(message.hasReachedVelocityLimit);
    }
    if (message.readyForNextPhoto === true) {
      writer.uint32(112).bool(message.readyForNextPhoto);
    }
    if (message.currentTimeoutDuration !== 0) {
      writer.uint32(125).float(message.currentTimeoutDuration);
    }
    if (message.timedOut === true) {
      writer.uint32(128).bool(message.timedOut);
    }
    if (message.vehicleBodyVisible === true) {
      writer.uint32(136).bool(message.vehicleBodyVisible);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StopForPhotoDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopForPhotoDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.waypointUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.navTVehicle = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.navTWaypoint = Vector3fPb.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.distance = reader.float();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.vehiclePitch = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.waypointPitch = reader.float();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.pitchDiff = reader.float();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.vehicleHeading = reader.float();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.waypointHeading = reader.float();
          continue;
        case 11:
          if (tag !== 93) {
            break;
          }

          message.headingDiff = reader.float();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.hasReachedWaypoint = reader.bool();
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.hasReachedVelocityLimit = reader.bool();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.readyForNextPhoto = reader.bool();
          continue;
        case 15:
          if (tag !== 125) {
            break;
          }

          message.currentTimeoutDuration = reader.float();
          continue;
        case 16:
          if (tag !== 128) {
            break;
          }

          message.timedOut = reader.bool();
          continue;
        case 17:
          if (tag !== 136) {
            break;
          }

          message.vehicleBodyVisible = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopForPhotoDebug {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      waypointUuid: isSet(object.waypointUuid) ? Uuid.fromJSON(object.waypointUuid) : undefined,
      navTVehicle: isSet(object.navTVehicle) ? Vector3fPb.fromJSON(object.navTVehicle) : undefined,
      navTWaypoint: isSet(object.navTWaypoint) ? Vector3fPb.fromJSON(object.navTWaypoint) : undefined,
      distance: isSet(object.distance) ? globalThis.Number(object.distance) : 0,
      vehiclePitch: isSet(object.vehiclePitch) ? globalThis.Number(object.vehiclePitch) : 0,
      waypointPitch: isSet(object.waypointPitch) ? globalThis.Number(object.waypointPitch) : 0,
      pitchDiff: isSet(object.pitchDiff) ? globalThis.Number(object.pitchDiff) : 0,
      vehicleHeading: isSet(object.vehicleHeading) ? globalThis.Number(object.vehicleHeading) : 0,
      waypointHeading: isSet(object.waypointHeading) ? globalThis.Number(object.waypointHeading) : 0,
      headingDiff: isSet(object.headingDiff) ? globalThis.Number(object.headingDiff) : 0,
      hasReachedWaypoint: isSet(object.hasReachedWaypoint) ? globalThis.Boolean(object.hasReachedWaypoint) : false,
      hasReachedVelocityLimit: isSet(object.hasReachedVelocityLimit)
        ? globalThis.Boolean(object.hasReachedVelocityLimit)
        : false,
      readyForNextPhoto: isSet(object.readyForNextPhoto) ? globalThis.Boolean(object.readyForNextPhoto) : false,
      currentTimeoutDuration: isSet(object.currentTimeoutDuration)
        ? globalThis.Number(object.currentTimeoutDuration)
        : 0,
      timedOut: isSet(object.timedOut) ? globalThis.Boolean(object.timedOut) : false,
      vehicleBodyVisible: isSet(object.vehicleBodyVisible) ? globalThis.Boolean(object.vehicleBodyVisible) : false,
    };
  },

  toJSON(message: StopForPhotoDebug): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.waypointUuid !== undefined) {
      obj.waypointUuid = Uuid.toJSON(message.waypointUuid);
    }
    if (message.navTVehicle !== undefined) {
      obj.navTVehicle = Vector3fPb.toJSON(message.navTVehicle);
    }
    if (message.navTWaypoint !== undefined) {
      obj.navTWaypoint = Vector3fPb.toJSON(message.navTWaypoint);
    }
    if (message.distance !== 0) {
      obj.distance = message.distance;
    }
    if (message.vehiclePitch !== 0) {
      obj.vehiclePitch = message.vehiclePitch;
    }
    if (message.waypointPitch !== 0) {
      obj.waypointPitch = message.waypointPitch;
    }
    if (message.pitchDiff !== 0) {
      obj.pitchDiff = message.pitchDiff;
    }
    if (message.vehicleHeading !== 0) {
      obj.vehicleHeading = message.vehicleHeading;
    }
    if (message.waypointHeading !== 0) {
      obj.waypointHeading = message.waypointHeading;
    }
    if (message.headingDiff !== 0) {
      obj.headingDiff = message.headingDiff;
    }
    if (message.hasReachedWaypoint === true) {
      obj.hasReachedWaypoint = message.hasReachedWaypoint;
    }
    if (message.hasReachedVelocityLimit === true) {
      obj.hasReachedVelocityLimit = message.hasReachedVelocityLimit;
    }
    if (message.readyForNextPhoto === true) {
      obj.readyForNextPhoto = message.readyForNextPhoto;
    }
    if (message.currentTimeoutDuration !== 0) {
      obj.currentTimeoutDuration = message.currentTimeoutDuration;
    }
    if (message.timedOut === true) {
      obj.timedOut = message.timedOut;
    }
    if (message.vehicleBodyVisible === true) {
      obj.vehicleBodyVisible = message.vehicleBodyVisible;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopForPhotoDebug>, I>>(base?: I): StopForPhotoDebug {
    return StopForPhotoDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopForPhotoDebug>, I>>(object: I): StopForPhotoDebug {
    const message = createBaseStopForPhotoDebug();
    message.utime = object.utime ?? 0;
    message.waypointUuid = (object.waypointUuid !== undefined && object.waypointUuid !== null)
      ? Uuid.fromPartial(object.waypointUuid)
      : undefined;
    message.navTVehicle = (object.navTVehicle !== undefined && object.navTVehicle !== null)
      ? Vector3fPb.fromPartial(object.navTVehicle)
      : undefined;
    message.navTWaypoint = (object.navTWaypoint !== undefined && object.navTWaypoint !== null)
      ? Vector3fPb.fromPartial(object.navTWaypoint)
      : undefined;
    message.distance = object.distance ?? 0;
    message.vehiclePitch = object.vehiclePitch ?? 0;
    message.waypointPitch = object.waypointPitch ?? 0;
    message.pitchDiff = object.pitchDiff ?? 0;
    message.vehicleHeading = object.vehicleHeading ?? 0;
    message.waypointHeading = object.waypointHeading ?? 0;
    message.headingDiff = object.headingDiff ?? 0;
    message.hasReachedWaypoint = object.hasReachedWaypoint ?? false;
    message.hasReachedVelocityLimit = object.hasReachedVelocityLimit ?? false;
    message.readyForNextPhoto = object.readyForNextPhoto ?? false;
    message.currentTimeoutDuration = object.currentTimeoutDuration ?? 0;
    message.timedOut = object.timedOut ?? false;
    message.vehicleBodyVisible = object.vehicleBodyVisible ?? false;
    return message;
  },
};

function createBaseEnqueuedPhotoCaptureRequestDebug(): EnqueuedPhotoCaptureRequestDebug {
  return {
    utime: 0,
    waypointUuid: undefined,
    timedOut: false,
    linearVelocityLimitReached: false,
    angularVelocityLimitReached: false,
    timeSinceEnqueued: 0,
    linearVelocityLimit: 0,
    angularVelocityLimit: 0,
    currentLinearVelocity: 0,
    currentAngularVelocity: 0,
  };
}

export const EnqueuedPhotoCaptureRequestDebug = {
  encode(message: EnqueuedPhotoCaptureRequestDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    if (message.waypointUuid !== undefined) {
      Uuid.encode(message.waypointUuid, writer.uint32(18).fork()).ldelim();
    }
    if (message.timedOut === true) {
      writer.uint32(24).bool(message.timedOut);
    }
    if (message.linearVelocityLimitReached === true) {
      writer.uint32(32).bool(message.linearVelocityLimitReached);
    }
    if (message.angularVelocityLimitReached === true) {
      writer.uint32(40).bool(message.angularVelocityLimitReached);
    }
    if (message.timeSinceEnqueued !== 0) {
      writer.uint32(53).float(message.timeSinceEnqueued);
    }
    if (message.linearVelocityLimit !== 0) {
      writer.uint32(61).float(message.linearVelocityLimit);
    }
    if (message.angularVelocityLimit !== 0) {
      writer.uint32(69).float(message.angularVelocityLimit);
    }
    if (message.currentLinearVelocity !== 0) {
      writer.uint32(77).float(message.currentLinearVelocity);
    }
    if (message.currentAngularVelocity !== 0) {
      writer.uint32(85).float(message.currentAngularVelocity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EnqueuedPhotoCaptureRequestDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnqueuedPhotoCaptureRequestDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.waypointUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.timedOut = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.linearVelocityLimitReached = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.angularVelocityLimitReached = reader.bool();
          continue;
        case 6:
          if (tag !== 53) {
            break;
          }

          message.timeSinceEnqueued = reader.float();
          continue;
        case 7:
          if (tag !== 61) {
            break;
          }

          message.linearVelocityLimit = reader.float();
          continue;
        case 8:
          if (tag !== 69) {
            break;
          }

          message.angularVelocityLimit = reader.float();
          continue;
        case 9:
          if (tag !== 77) {
            break;
          }

          message.currentLinearVelocity = reader.float();
          continue;
        case 10:
          if (tag !== 85) {
            break;
          }

          message.currentAngularVelocity = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnqueuedPhotoCaptureRequestDebug {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      waypointUuid: isSet(object.waypointUuid) ? Uuid.fromJSON(object.waypointUuid) : undefined,
      timedOut: isSet(object.timedOut) ? globalThis.Boolean(object.timedOut) : false,
      linearVelocityLimitReached: isSet(object.linearVelocityLimitReached)
        ? globalThis.Boolean(object.linearVelocityLimitReached)
        : false,
      angularVelocityLimitReached: isSet(object.angularVelocityLimitReached)
        ? globalThis.Boolean(object.angularVelocityLimitReached)
        : false,
      timeSinceEnqueued: isSet(object.timeSinceEnqueued) ? globalThis.Number(object.timeSinceEnqueued) : 0,
      linearVelocityLimit: isSet(object.linearVelocityLimit) ? globalThis.Number(object.linearVelocityLimit) : 0,
      angularVelocityLimit: isSet(object.angularVelocityLimit) ? globalThis.Number(object.angularVelocityLimit) : 0,
      currentLinearVelocity: isSet(object.currentLinearVelocity) ? globalThis.Number(object.currentLinearVelocity) : 0,
      currentAngularVelocity: isSet(object.currentAngularVelocity)
        ? globalThis.Number(object.currentAngularVelocity)
        : 0,
    };
  },

  toJSON(message: EnqueuedPhotoCaptureRequestDebug): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.waypointUuid !== undefined) {
      obj.waypointUuid = Uuid.toJSON(message.waypointUuid);
    }
    if (message.timedOut === true) {
      obj.timedOut = message.timedOut;
    }
    if (message.linearVelocityLimitReached === true) {
      obj.linearVelocityLimitReached = message.linearVelocityLimitReached;
    }
    if (message.angularVelocityLimitReached === true) {
      obj.angularVelocityLimitReached = message.angularVelocityLimitReached;
    }
    if (message.timeSinceEnqueued !== 0) {
      obj.timeSinceEnqueued = message.timeSinceEnqueued;
    }
    if (message.linearVelocityLimit !== 0) {
      obj.linearVelocityLimit = message.linearVelocityLimit;
    }
    if (message.angularVelocityLimit !== 0) {
      obj.angularVelocityLimit = message.angularVelocityLimit;
    }
    if (message.currentLinearVelocity !== 0) {
      obj.currentLinearVelocity = message.currentLinearVelocity;
    }
    if (message.currentAngularVelocity !== 0) {
      obj.currentAngularVelocity = message.currentAngularVelocity;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnqueuedPhotoCaptureRequestDebug>, I>>(
    base?: I,
  ): EnqueuedPhotoCaptureRequestDebug {
    return EnqueuedPhotoCaptureRequestDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnqueuedPhotoCaptureRequestDebug>, I>>(
    object: I,
  ): EnqueuedPhotoCaptureRequestDebug {
    const message = createBaseEnqueuedPhotoCaptureRequestDebug();
    message.utime = object.utime ?? 0;
    message.waypointUuid = (object.waypointUuid !== undefined && object.waypointUuid !== null)
      ? Uuid.fromPartial(object.waypointUuid)
      : undefined;
    message.timedOut = object.timedOut ?? false;
    message.linearVelocityLimitReached = object.linearVelocityLimitReached ?? false;
    message.angularVelocityLimitReached = object.angularVelocityLimitReached ?? false;
    message.timeSinceEnqueued = object.timeSinceEnqueued ?? 0;
    message.linearVelocityLimit = object.linearVelocityLimit ?? 0;
    message.angularVelocityLimit = object.angularVelocityLimit ?? 0;
    message.currentLinearVelocity = object.currentLinearVelocity ?? 0;
    message.currentAngularVelocity = object.currentAngularVelocity ?? 0;
    return message;
  },
};

function createBasePhotoCaptureStateDebug(): PhotoCaptureStateDebug {
  return {
    photoRequestNonce: 0,
    photoFormat: 0,
    waypointUuid: undefined,
    requestUtime: 0,
    captureUtime: 0,
    inProgressExposedUtime: 0,
    captureSuccessfulUtime: 0,
    captureFailedUtime: 0,
    readyForNextUtime: 0,
    photoPath: "",
    resultValid: false,
    result: 0,
    velocityLimitTimedOut: false,
    ispResultTimedOut: false,
  };
}

export const PhotoCaptureStateDebug = {
  encode(message: PhotoCaptureStateDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.photoRequestNonce !== 0) {
      writer.uint32(8).int64(message.photoRequestNonce);
    }
    if (message.photoFormat !== 0) {
      writer.uint32(16).int32(message.photoFormat);
    }
    if (message.waypointUuid !== undefined) {
      Uuid.encode(message.waypointUuid, writer.uint32(26).fork()).ldelim();
    }
    if (message.requestUtime !== 0) {
      writer.uint32(32).int64(message.requestUtime);
    }
    if (message.captureUtime !== 0) {
      writer.uint32(40).int64(message.captureUtime);
    }
    if (message.inProgressExposedUtime !== 0) {
      writer.uint32(48).int64(message.inProgressExposedUtime);
    }
    if (message.captureSuccessfulUtime !== 0) {
      writer.uint32(56).int64(message.captureSuccessfulUtime);
    }
    if (message.captureFailedUtime !== 0) {
      writer.uint32(64).int64(message.captureFailedUtime);
    }
    if (message.readyForNextUtime !== 0) {
      writer.uint32(72).int64(message.readyForNextUtime);
    }
    if (message.photoPath !== "") {
      writer.uint32(82).string(message.photoPath);
    }
    if (message.resultValid === true) {
      writer.uint32(88).bool(message.resultValid);
    }
    if (message.result !== 0) {
      writer.uint32(96).int32(message.result);
    }
    if (message.velocityLimitTimedOut === true) {
      writer.uint32(104).bool(message.velocityLimitTimedOut);
    }
    if (message.ispResultTimedOut === true) {
      writer.uint32(112).bool(message.ispResultTimedOut);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PhotoCaptureStateDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePhotoCaptureStateDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.photoRequestNonce = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.photoFormat = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.waypointUuid = Uuid.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.requestUtime = longToNumber(reader.int64() as Long);
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.captureUtime = longToNumber(reader.int64() as Long);
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.inProgressExposedUtime = longToNumber(reader.int64() as Long);
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.captureSuccessfulUtime = longToNumber(reader.int64() as Long);
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.captureFailedUtime = longToNumber(reader.int64() as Long);
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.readyForNextUtime = longToNumber(reader.int64() as Long);
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.photoPath = reader.string();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.resultValid = reader.bool();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.result = reader.int32() as any;
          continue;
        case 13:
          if (tag !== 104) {
            break;
          }

          message.velocityLimitTimedOut = reader.bool();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.ispResultTimedOut = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PhotoCaptureStateDebug {
    return {
      photoRequestNonce: isSet(object.photoRequestNonce) ? globalThis.Number(object.photoRequestNonce) : 0,
      photoFormat: isSet(object.photoFormat) ? photoFormat_EnumFromJSON(object.photoFormat) : 0,
      waypointUuid: isSet(object.waypointUuid) ? Uuid.fromJSON(object.waypointUuid) : undefined,
      requestUtime: isSet(object.requestUtime) ? globalThis.Number(object.requestUtime) : 0,
      captureUtime: isSet(object.captureUtime) ? globalThis.Number(object.captureUtime) : 0,
      inProgressExposedUtime: isSet(object.inProgressExposedUtime)
        ? globalThis.Number(object.inProgressExposedUtime)
        : 0,
      captureSuccessfulUtime: isSet(object.captureSuccessfulUtime)
        ? globalThis.Number(object.captureSuccessfulUtime)
        : 0,
      captureFailedUtime: isSet(object.captureFailedUtime) ? globalThis.Number(object.captureFailedUtime) : 0,
      readyForNextUtime: isSet(object.readyForNextUtime) ? globalThis.Number(object.readyForNextUtime) : 0,
      photoPath: isSet(object.photoPath) ? globalThis.String(object.photoPath) : "",
      resultValid: isSet(object.resultValid) ? globalThis.Boolean(object.resultValid) : false,
      result: isSet(object.result) ? photoCaptureResult_EnumFromJSON(object.result) : 0,
      velocityLimitTimedOut: isSet(object.velocityLimitTimedOut)
        ? globalThis.Boolean(object.velocityLimitTimedOut)
        : false,
      ispResultTimedOut: isSet(object.ispResultTimedOut) ? globalThis.Boolean(object.ispResultTimedOut) : false,
    };
  },

  toJSON(message: PhotoCaptureStateDebug): unknown {
    const obj: any = {};
    if (message.photoRequestNonce !== 0) {
      obj.photoRequestNonce = Math.round(message.photoRequestNonce);
    }
    if (message.photoFormat !== 0) {
      obj.photoFormat = photoFormat_EnumToJSON(message.photoFormat);
    }
    if (message.waypointUuid !== undefined) {
      obj.waypointUuid = Uuid.toJSON(message.waypointUuid);
    }
    if (message.requestUtime !== 0) {
      obj.requestUtime = Math.round(message.requestUtime);
    }
    if (message.captureUtime !== 0) {
      obj.captureUtime = Math.round(message.captureUtime);
    }
    if (message.inProgressExposedUtime !== 0) {
      obj.inProgressExposedUtime = Math.round(message.inProgressExposedUtime);
    }
    if (message.captureSuccessfulUtime !== 0) {
      obj.captureSuccessfulUtime = Math.round(message.captureSuccessfulUtime);
    }
    if (message.captureFailedUtime !== 0) {
      obj.captureFailedUtime = Math.round(message.captureFailedUtime);
    }
    if (message.readyForNextUtime !== 0) {
      obj.readyForNextUtime = Math.round(message.readyForNextUtime);
    }
    if (message.photoPath !== "") {
      obj.photoPath = message.photoPath;
    }
    if (message.resultValid === true) {
      obj.resultValid = message.resultValid;
    }
    if (message.result !== 0) {
      obj.result = photoCaptureResult_EnumToJSON(message.result);
    }
    if (message.velocityLimitTimedOut === true) {
      obj.velocityLimitTimedOut = message.velocityLimitTimedOut;
    }
    if (message.ispResultTimedOut === true) {
      obj.ispResultTimedOut = message.ispResultTimedOut;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PhotoCaptureStateDebug>, I>>(base?: I): PhotoCaptureStateDebug {
    return PhotoCaptureStateDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PhotoCaptureStateDebug>, I>>(object: I): PhotoCaptureStateDebug {
    const message = createBasePhotoCaptureStateDebug();
    message.photoRequestNonce = object.photoRequestNonce ?? 0;
    message.photoFormat = object.photoFormat ?? 0;
    message.waypointUuid = (object.waypointUuid !== undefined && object.waypointUuid !== null)
      ? Uuid.fromPartial(object.waypointUuid)
      : undefined;
    message.requestUtime = object.requestUtime ?? 0;
    message.captureUtime = object.captureUtime ?? 0;
    message.inProgressExposedUtime = object.inProgressExposedUtime ?? 0;
    message.captureSuccessfulUtime = object.captureSuccessfulUtime ?? 0;
    message.captureFailedUtime = object.captureFailedUtime ?? 0;
    message.readyForNextUtime = object.readyForNextUtime ?? 0;
    message.photoPath = object.photoPath ?? "";
    message.resultValid = object.resultValid ?? false;
    message.result = object.result ?? 0;
    message.velocityLimitTimedOut = object.velocityLimitTimedOut ?? false;
    message.ispResultTimedOut = object.ispResultTimedOut ?? false;
    return message;
  },
};

function createBaseActivePhotoCapturesDebug(): ActivePhotoCapturesDebug {
  return { utime: 0, activeEoPhotoCaptures: [], activeIrPhotoCaptures: [] };
}

export const ActivePhotoCapturesDebug = {
  encode(message: ActivePhotoCapturesDebug, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.utime !== 0) {
      writer.uint32(8).int64(message.utime);
    }
    for (const v of message.activeEoPhotoCaptures) {
      PhotoCaptureStateDebug.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    for (const v of message.activeIrPhotoCaptures) {
      PhotoCaptureStateDebug.encode(v!, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ActivePhotoCapturesDebug {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseActivePhotoCapturesDebug();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.utime = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.activeEoPhotoCaptures.push(PhotoCaptureStateDebug.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.activeIrPhotoCaptures.push(PhotoCaptureStateDebug.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ActivePhotoCapturesDebug {
    return {
      utime: isSet(object.utime) ? globalThis.Number(object.utime) : 0,
      activeEoPhotoCaptures: globalThis.Array.isArray(object?.activeEoPhotoCaptures)
        ? object.activeEoPhotoCaptures.map((e: any) => PhotoCaptureStateDebug.fromJSON(e))
        : [],
      activeIrPhotoCaptures: globalThis.Array.isArray(object?.activeIrPhotoCaptures)
        ? object.activeIrPhotoCaptures.map((e: any) => PhotoCaptureStateDebug.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ActivePhotoCapturesDebug): unknown {
    const obj: any = {};
    if (message.utime !== 0) {
      obj.utime = Math.round(message.utime);
    }
    if (message.activeEoPhotoCaptures?.length) {
      obj.activeEoPhotoCaptures = message.activeEoPhotoCaptures.map((e) => PhotoCaptureStateDebug.toJSON(e));
    }
    if (message.activeIrPhotoCaptures?.length) {
      obj.activeIrPhotoCaptures = message.activeIrPhotoCaptures.map((e) => PhotoCaptureStateDebug.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ActivePhotoCapturesDebug>, I>>(base?: I): ActivePhotoCapturesDebug {
    return ActivePhotoCapturesDebug.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ActivePhotoCapturesDebug>, I>>(object: I): ActivePhotoCapturesDebug {
    const message = createBaseActivePhotoCapturesDebug();
    message.utime = object.utime ?? 0;
    message.activeEoPhotoCaptures = object.activeEoPhotoCaptures?.map((e) => PhotoCaptureStateDebug.fromPartial(e)) ||
      [];
    message.activeIrPhotoCaptures = object.activeIrPhotoCaptures?.map((e) => PhotoCaptureStateDebug.fromPartial(e)) ||
      [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
